import React, { Component } from 'react';
import '../css/ticket.css'
import { FORMAT_NUMBER, CURRENCY, SYMBOL, noCreditGroupNumbers, points_Card, SERVICE_RESPONSE, priceDecimalPrecision, needTransferReference, Sections } from '../libs/utils/Const';
import TicketModal from './TicketModal';
import { AppsCashCuts, NiubizModal, StandardSelectModal, ToolTip, ValidationModal } from '../components';
import moment from "moment";
import { PayMethodCounter } from "../components/NewOrder";
import ApiClient from '../libs/apiClient';
import $ from "jquery";
import Select from 'react-select';
const apiClient = ApiClient.getInstance();

let paymentSelected = false;

class BillModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showNiubizModal: false,
            currPayment: new PayMethodCounter(),
            listFise: [],
            showFiseModal: false,
            selectedFise: [],
            voucher: null,
        };
    }

    async componentWillUnmount() {
        let auxPaymentSaleModel = new PayMethodCounter();
        this.RefreshPaymentSaleModel(auxPaymentSaleModel);

    }

    async componentDidMount() {
        const { GetBankAccounts } = this.props
        GetBankAccounts();
        await this.SumOfAmounts();
        paymentSelected = false

    }

    ValidateAmount = (value) => {
        const { showAlert } = this.props;
        if (isNaN(value)) {
            showAlert({ type: 'warning', message: 'Cantidad invalida', timeOut: 2000 });
            return false;
        }
        return true;
    }

    SumOfAmounts = async () => {
        const { RefreshOrder, newOrderModel, PaymentSaleModel } = this.props;
        let totalAmount = 0;
        for (const payAdded of newOrderModel.PaymentsToSale) {
            if (Number(payAdded.TypeMethod) !== 117) {
                if (payAdded.currentCheck) {//SOLO VOUCHERS CON REDONDEO
                    totalAmount = totalAmount + Number(payAdded.totalRemaining);
                } else {
                    totalAmount = totalAmount + Number(payAdded.Amount);
                }
            }

        }
        newOrderModel.TotalRecibido = totalAmount;
        newOrderModel.TotalRestante = totalAmount ? (totalAmount - newOrderModel.Total) > 0 ? totalAmount - newOrderModel.Total : 0 : 0;
        newOrderModel.RemainingAmount = parseFloat(Number(newOrderModel.Total) - Number(totalAmount)).toFixed(priceDecimalPrecision);


        // PaymentSaleModel.Amount = newOrderModel.RemainingAmount > 0 ? Number(newOrderModel.RemainingAmount) : 0;

        PaymentSaleModel.Amount = Number(newOrderModel.RemainingAmount)
        // newOrderModel.TotalRestante = totalAmount < newOrderModel.Total ?  newOrderModel.Total - totalAmount : 0;
        await RefreshOrder(newOrderModel);
        await this.RefreshPaymentSaleModel(PaymentSaleModel);
    }

    AffectSubTotal = async (downPayments) => {
        const { newOrderModel, RefreshOrder } = this.props
        let subtotalDP = 0;
        let totalTaxDP = 0;

        for (const payment of downPayments) {
            const { auxObjDP: { BaseAmnt, DpmAmnt, DpmAppl, VatPercent }, Amount } = payment;
            const taxRate = Number((Number(VatPercent) / 100).toFixed(priceDecimalPrecision));
            const orgTaxDP = Number((Number(DpmAmnt) * taxRate).toFixed(priceDecimalPrecision));
            const applTaxDP = Number((Number(DpmAppl) * taxRate).toFixed(priceDecimalPrecision));
            const taxDP = Math.round((Number(Amount) * taxRate) * 100) / 100;//REDONDEADO A 2 DECIMALES PARA COINCIDIR CON CALCULOS COUNTER
            const maxTaxValue = Number((orgTaxDP - applTaxDP).toFixed(priceDecimalPrecision));
            subtotalDP += Number(Amount);
            if (taxDP > maxTaxValue || Number(Amount) === Number(BaseAmnt)) { totalTaxDP += maxTaxValue; }
            else { totalTaxDP += taxDP; }
        }

        newOrderModel.Subtotal = Number(newOrderModel.Subtotal) > (subtotalDP) ? (Number(newOrderModel.Subtotal) - (subtotalDP)).toFixed(priceDecimalPrecision) : "0.00";
        newOrderModel.Taxes = (Number(newOrderModel.Taxes) - (totalTaxDP)).toFixed(priceDecimalPrecision);
        newOrderModel.Total = (Number(newOrderModel.Total) - (subtotalDP + totalTaxDP)).toFixed(priceDecimalPrecision);
        RefreshOrder(newOrderModel);
    }

    DoSearch = async (data, searchTerm) => {
        const tableReg = document.getElementById(data);
        const searchText = document.getElementById(searchTerm).value.toLowerCase();
        let total = 0;
        // Recorremos todas las filas con contenido de la tabla
        for (let i = 0; i < tableReg.rows.length; i++) {
            // Si el td tiene la clase "noSearch" no se busca en su contenido
            // if (tableReg.rows[i].classList.contains("noSearch")) {
            //     continue;
            // }
            let found = false;
            const cellsOfRow = tableReg.rows[i].getElementsByTagName('td');
            // Recorremos todas las celdas
            for (let j = 0; j < cellsOfRow.length && !found; j++) {
                const compareWith = cellsOfRow[j].innerHTML.toLowerCase();
                // Buscamos el texto en el contenido de la celda
                if (searchText.length === 0 || compareWith.indexOf(searchText) > -1) {
                    found = true;
                    total++;
                }
            }
            if (found) {
                tableReg.rows[i].style.display = '';
            } else {
                // si no ha encontrado ninguna coincidencia, esconde la
                // fila de la tabla
                tableReg.rows[i].style.display = 'none';
            }
        }
        // mostramos las coincidencias
        const lastTR = tableReg.rows[tableReg.rows.length - 1];
        const td = lastTR.querySelector("td");
        lastTR.classList.remove("hide", "red");
        if (searchText == "") {
            lastTR.classList.add("hide");
        } else if (total) {
            // td.innerHTML="Se ha encontrado "+total+" coincidencia"+((total>1)?"s":"");
        } else {
            // lastTR.classList.add("red");
            // td.innerHTML="No se han encontrado coincidencias";
        }
    }

    RefreshPaymentSaleModel = (PaymentSaleModel) => {
        const { RefreshPaymentSaleModel, } = this.props;
        RefreshPaymentSaleModel(PaymentSaleModel);
    }

    //#region ######### CHANGE PAYMENT GENERAL FIELDS ############################################################ 
    ChangeAmount = (value) => {
        const { PaymentSaleModel, showAlert } = this.props;
        if (isNaN(value) || Number(value) < 0) {
            showAlert({ type: "warning", message: `Agregue un valor valido` });
            return
        }

        PaymentSaleModel.Amount = Number(value);
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    }

    ChangeTypePayMethod = (payMethod) => {
        const { PaymentSaleModel, newOrderModel, RefreshReturnFolioAmount, clearFise, showAlert } = this.props;
        const payment = newOrderModel.PaymentsToSale.find(payment => ![14, 117].includes(Number(payment.TypeMethod)));
        const currency = payment?.currency || PaymentSaleModel.currency || 'PEN';
        if (currency === 'USD' && ![3, 14, 117].includes(Number(payMethod.type))) {
            return showAlert({ type: 'warning', message: 'Los pagos en USD solo admiten transferencias.' });
        }
        PaymentSaleModel.idPMBO = payMethod.idPMBO;
        PaymentSaleModel.PM_Name = payMethod.name;
        PaymentSaleModel.PM_Code = payMethod.idAPMBO;
        PaymentSaleModel.TypeMethod = payMethod.type;
        PaymentSaleModel.AcctCode = payMethod.AcctCode;
        PaymentSaleModel.CreditCard = payMethod.idCard || null;
        PaymentSaleModel.PaycheckNum = '';
        PaymentSaleModel.DatePaycheck = moment(new Date()).format("YYYY-MM-DD");
        PaymentSaleModel.BankCode = '';
        PaymentSaleModel.BankName = '';

        PaymentSaleModel.CardNum = '';
        PaymentSaleModel.VoucherNum = '';
        PaymentSaleModel.Indentification = '';
        PaymentSaleModel.PhoneNum = '';

        PaymentSaleModel.TransferNum = '';
        PaymentSaleModel.PayAccountNum = '';
        PaymentSaleModel.ReturnFolio = '';
        PaymentSaleModel.AvailableAmount = 0;

        // PaymentSaleModel.Amount = Number(0);
        PaymentSaleModel.Amount = Number(newOrderModel.RemainingAmount);

        PaymentSaleModel.auxObjDP = {};
        PaymentSaleModel.DocEntryDP = '';
        PaymentSaleModel.AmountDP = 0;
        PaymentSaleModel.NumAtCardDP = '';

        //#region Flujo de caja
        PaymentSaleModel.CfwRlvnt = payMethod?.CfwRlvnt || null;
        PaymentSaleModel.Finanse = payMethod?.Finanse || null;

        PaymentSaleModel.transferCFWId = payMethod?.transferCFWId || null; // Para transferencias
        PaymentSaleModel.needTransferCFW = payMethod?.needTransferCFW || false; // Para transferencias
        PaymentSaleModel.transferCFWOptions = payMethod?.transferCFWOptions || []; // Para transferencias

        PaymentSaleModel.cashCFWId = payMethod?.cashCFWId || null; // Para efectivo
        PaymentSaleModel.needCashCFW = payMethod?.needCashCFW || false; // Para efectivo
        PaymentSaleModel.cashCFWOptions = payMethod?.cashCFWOptions || []; // Para efectivo

        PaymentSaleModel.checkCFWId = payMethod?.checkCFWId || null; // Para cheques
        PaymentSaleModel.needCheckCFW = payMethod?.needCheckCFW || false; // Para cheques
        PaymentSaleModel.checkCFWOptions = payMethod?.checkCFWOptions || []; // Para cheques
        //#endregion Flujo de caja

        this.RefreshPaymentSaleModel(PaymentSaleModel);
        RefreshReturnFolioAmount(0)
        clearFise()
        paymentSelected = true;
        if ((Number(PaymentSaleModel.TypeMethod) === 3)) {
            PaymentSaleModel.currency = currency;
            PaymentSaleModel.ifChangeRate = currency === 'USD';
            PaymentSaleModel.ChangeRate_1 = currency === 'USD' ? payment?.ChangeRate_1 || this.props.currencyRate : 1;
            PaymentSaleModel.totalOriginal = PaymentSaleModel.Amount;
            PaymentSaleModel.total = Number((PaymentSaleModel.Amount / (PaymentSaleModel.ChangeRate_1 || 1)).toFixed(2));
            PaymentSaleModel.totalRemaining = PaymentSaleModel.Amount
        } else {
            PaymentSaleModel.currency = 'PEN';
            PaymentSaleModel.ifChangeRate = false;
            PaymentSaleModel.ChangeRate_1 = 1;
        }
    }
    //#endregion

    //#region ######### CHANGE FIELDS PAYCHECKS ############################################################ 
    ChangePaycheckNum = (value) => {
        const { PaymentSaleModel } = this.props;
        PaymentSaleModel.PaycheckNum = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    }

    ChangeDatePayCheck = async (value) => {
        const { PaymentSaleModel } = this.props;
        PaymentSaleModel.DatePaycheck = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangeBank = async (bankCode) => {
        const { PaymentSaleModel, BankAccounts } = this.props;
        const found = await BankAccounts.find(account => account.BankCode === bankCode);
        PaymentSaleModel.BankCode = found.BankCode;
        PaymentSaleModel.BankName = found.BankName;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    }
    //#endregion

    //#region ######### CHANGE FIELDS CARD CREDIT OR DEBIT ############################################################ 
    ChangeCardNum = async (value) => {
        const { PaymentSaleModel, showAlert } = this.props;
        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Carácter inválido' });
            return;
        }
        PaymentSaleModel.CardNum = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangeVoucherNum = async (value) => {
        const { PaymentSaleModel, showAlert } = this.props;
        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Carácter inválido' });
            return;
        }
        PaymentSaleModel.VoucherNum = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangeIndentification = async (value) => {
        const { PaymentSaleModel, showAlert } = this.props;
        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Caracter inválido' });
            return;
        }
        PaymentSaleModel.Indentification = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangePhoneNum = async (value) => {
        const { PaymentSaleModel, showAlert } = this.props;
        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Caracter inválido' });
            return;
        }
        PaymentSaleModel.PhoneNum = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangeValidCard = async (value) => {
        const { PaymentSaleModel, showAlert } = this.props;
        value = value.replace('/', '');
        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Caracter inválido' });
            return;
        }
        if (value.length > 2) {
            if (value.slice(0, 2) > 12) {
                showAlert({ type: 'info', message: 'Fecha incorrecta' });
                return;
            }
            value = value.slice(0, 2) + '/' + value.slice(2);
        }
        PaymentSaleModel.CardValid = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangeValidateValidCard = async (value) => {
        const { PaymentSaleModel, showAlert } = this.props;
        if (PaymentSaleModel.CardValid.length < 5) {
            showAlert({ type: "warning", message: `La fecha de vencimiento de la tarjeta esta incompleta` });
            return
        }
    };
    //#endregion

    //#region ######### CHANGE FIELDS CARDS AND RETURNS ############################################################ 
    ChangeTransferNum = async (value) => {
        const { PaymentSaleModel } = this.props;
        PaymentSaleModel.TransferNum = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangePayAccountNum = async (value) => {
        const { PaymentSaleModel } = this.props;
        PaymentSaleModel.PayAccountNum = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangeReturnFolio = async (value) => {
        const { PaymentSaleModel, RefreshReturnFolioAmount } = this.props;
        PaymentSaleModel.ReturnFolio = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
        RefreshReturnFolioAmount(0)
    };

    ChangeReturnAvailableAmount = async (value) => {
        const { PaymentSaleModel } = this.props;
        PaymentSaleModel.AvailableAmount = Number(value);
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };
    //#endregion

    //#region ######### CHANGE FIELDS DOWNPAYMENTS ############################################################ 
    ChangeDocEntryDP = async (downPay) => {
        const { PaymentSaleModel, newOrderModel } = this.props;
        PaymentSaleModel.auxObjDP = downPay;
        PaymentSaleModel.DocEntryDP = downPay.DocEntry;
        PaymentSaleModel.Amount_1 = PaymentSaleModel.Amount;
        PaymentSaleModel.U_UDF_UUID = downPay.U_UDF_UUID;
        PaymentSaleModel.FORMA_PAGO = downPay.FORMA_PAGO;
        PaymentSaleModel.Amount = newOrderModel.TotalRecibido === 0 && Number(newOrderModel.Subtotal) <= downPay.BaseAmnt ? Number(newOrderModel.Subtotal).toFixed(2) : Number(downPay.BaseAmnt).toFixed(2);
        this.RefreshPaymentSaleModel(PaymentSaleModel);
        // this.ChangeAmount(downPay.BaseAmnt);
    };
    //#endregion

    //#region ######### CHANGE FIELDS CREDITNOTES ############################################################ 
    ChangeDocEntryCN = async (creditNote) => {
        const { PaymentSaleModel, newOrderModel } = this.props;
        PaymentSaleModel.auxObjCN = creditNote;
        PaymentSaleModel.DocEntryCN = creditNote.DocEntry;
        let creditNotes = newOrderModel.PaymentsToSale.length > 0 ? newOrderModel.PaymentsToSale.filter((payments) => payments.TypeMethod === '14') : [];
        PaymentSaleModel.Amount = (newOrderModel.TotalRecibido === 0 || creditNotes.length > 0) && Number(newOrderModel.RemainingAmount) <= creditNote.totalPago ? Number(newOrderModel.RemainingAmount - 0.01).toFixed(2) : Number(creditNote.totalPago).toFixed(2);
        PaymentSaleModel.Amount_1 = (newOrderModel.TotalRecibido === 0 || creditNotes.length > 0) && Number(newOrderModel.RemainingAmount) <= creditNote.totalPago ? Number(newOrderModel.RemainingAmount - 0.01).toFixed(2) : Number(creditNote.totalPago).toFixed(2);
        this.RefreshPaymentSaleModel(PaymentSaleModel);
        // this.ChangeAmount(creditNote.totalPago);
    };
    //#endregion

    //#region ################## POINTS CARD ################ ✔
    GetPercentDiscount = (taxRate, totalAmount, totalDiscount) => {
        if (isNaN(taxRate) || isNaN(totalAmount) || isNaN(totalDiscount)) return 0

        const priceWithTax = (1 + (taxRate * 0.01)) * totalAmount
        const discountPercent = (totalDiscount * 100) / priceWithTax
        if (isNaN(discountPercent)) {
            return 0
        }
        return parseFloat(discountPercent.toFixed(2)) || 0
    }
    ChangeSelectedPointsCard = async (totalPoints) => {
        const { PaymentSaleModel, newOrderModel, showAlert, ItemsGroupEWallet, RefreshTotal } = this.props;
        let puntosDisponibles = totalPoints;
        let valorPunto = Number(newOrderModel.valorPunto);
        let valorCompra = Number(newOrderModel.RemainingAmount);
        // Calcula el valor total de los puntos disponibles en pesos
        let valorPuntosEnPesos = puntosDisponibles * valorPunto;
        valorPuntosEnPesos = parseFloat(valorPuntosEnPesos).toFixed(4);
        // Determina cuánto se puede descontar
        let descuento = Math.min(valorPuntosEnPesos, valorCompra);
        // Calcula los puntos a descontar
        let puntosADescontar = Math.ceil(descuento / valorPunto);

        // Verifica si los puntos disponibles son suficientes para cubrir los puntos a descontar
        if (puntosDisponibles >= puntosADescontar) {
            // Aplica el descuento total
            showAlert({ type: "warning", message: `Se descontaran $${descuento.toFixed(2)} pesos del total de su compra.` });
            PaymentSaleModel.puntosADescontar = puntosADescontar;
            PaymentSaleModel.Amount = Number(descuento).toFixed(2);
        }

        // Monto final a pagar
        // let montoFinal = valorCompra - descuento;
        // console.log(`con<Monto final a pagar: ${montoFinal.toFixed(2)} pesos`);

        this.RefreshPaymentSaleModel(PaymentSaleModel);
        // RefreshTotal(newOrderModel)
    };
    //#endregion ################## POINTS CARD ################ ✔

    //#region ######### ADD OR REMOVE METHOD ############################################################ 
    addingPaymentSale = async () => {
        const { RefreshOrder, newOrderModel, PaymentSaleModel, showAlert, AddPay, ReturnFolioAmount, LaunchPaymentWithTerminalQuestion, FlagPayWithSantander = false, RefreshTotal, ItemsGroupEWallet, FISE, clearFise, toleranceInfo = [] } = this.props;

        const isSelectedPointsCard = newOrderModel.PaymentsToSale.find((payment) => payment.TypeMethod === '555');
        const isDifferentPointsCard = newOrderModel.PaymentsToSale.some((payment) => payment.TypeMethod !== '555');


        if (PaymentSaleModel.TypeMethod === '124') {
            if (!FISE) {
                return showAlert({ type: "warning", message: `Consulta el código FISE para continuar` });
            }
            if (Number(FISE?.U_importe ?? -1) != Number(PaymentSaleModel?.Amount ?? 0)) {
                return showAlert({ type: "warning", message: `El importe solo puede ser ${Number(FISE?.U_importe ?? -1)}` });
            }
            if (Number(FISE?.U_importe ?? -1) >= Number(newOrderModel?.Total ?? 0)) {
                return showAlert({ type: "warning", message: `Importe FISE [${Number(FISE?.U_importe ?? -1)}] no puede cubrir el total de la venta [${Number(newOrderModel?.Total ?? 0)}]` });
            }
        }

        if (((isSelectedPointsCard && PaymentSaleModel.TypeMethod !== '555') || (isDifferentPointsCard && PaymentSaleModel.TypeMethod === '555')) && points_Card) {
            showAlert({
                type: "warning",
                message: "No puedes mezclar el monedero electrónico con otro método de pago.",
                timeOut: 5000
            });
            return;
        }
        const isSantanderCard = this.findInName("SANTANDER", PaymentSaleModel.PM_Name) ?? false;
        let auxPaymentSaleModel = new PayMethodCounter();

        if (PaymentSaleModel.Amount === '' || Number(PaymentSaleModel.Amount) === 0) {
            showAlert({ type: "warning", message: `No es posible dejar el monto vació` });
            return
        }
        if (PaymentSaleModel.TypeMethod === '') {
            showAlert({ type: "warning", message: `No has seleccionado un método de pago` });
            return
        }

        let isCredit = newOrderModel.PaymentsToSale.find((paymentMethod) => Number(paymentMethod.TypeMethod) === -1);
        if ((Number(PaymentSaleModel.TypeMethod) !== -1 && isCredit) || (Number(PaymentSaleModel.TypeMethod) === -1 && newOrderModel.PaymentsToSale.length > 0)) {
            showAlert({ type: "warning", message: `No puedes utilizar métodos de pago distintos si utilizas crédito` });
            return
        }

        let isAmountExceeded = false;
        if (Number(PaymentSaleModel?.TypeMethod) === 3) {
            //#region VALIDACIÓN REDONDEO
            if (PaymentSaleModel.currentCheck) {
                const round2 = (value) =>
                    Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;
                const total = Number(String(PaymentSaleModel.total ?? 0).replace(/,/g, '')) * (PaymentSaleModel.ChangeRate_1 || 1);
                const remaining = Number(PaymentSaleModel?.totalRemaining ?? 0) -
                    Number(total)
                const restante = round2(
                    remaining
                );

                const currency = CURRENCY; // Desde counter solo se crea en esta moneda
                const currentTolerance = toleranceInfo?.find(t => t.CurrCode === currency || t.DocCurrCod === currency || t.ISOCurrCod === currency) ?? {};
                const TOLERANCE = restante > 0
                    ? Number(currentTolerance?.MaxOutDiff ?? 0) // Falta
                    : Number(currentTolerance?.MaxInDiff ?? 0); // Sobra

                if (Math.abs(restante) > TOLERANCE) {
                    return showAlert({
                        type: "warning",
                        message: `El depósito supera la tolerancia permitida. Restante: ${(Math.abs(restante))}`
                    });
                }
            } else {
                isAmountExceeded = Number(PaymentSaleModel.Amount) > Number(newOrderModel.RemainingAmount);
            }
        } else {
            isAmountExceeded = Number(PaymentSaleModel.Amount) > Number(newOrderModel.RemainingAmount);
        }

        if ((Number(PaymentSaleModel.TypeMethod) !== 0) && (isAmountExceeded) && (PaymentSaleModel.PM_Name && PaymentSaleModel.PM_Name !== '' ? !this.findInName('EFECTIVO', PaymentSaleModel.PM_Name.toUpperCase()) : false)) {
            showAlert({ type: "warning", message: `ACCIÓN NO PERMITIDA: LA CANTIDAD QUE INTENTAS AGREGAR CORRESPONDE A UN METODO DE PAGO DIFERENTE A EFECTIVO, POR LO QUE NO PODRÁS DAR CAMBIO AL CLIENTE. (DA CLICK PARA DESPARECER ESTA ALERTA) `, timeOut: 99999 });
            showAlert({ type: "info", message: `AYUDA: SI USAS UN METODO DE DE PAGO DIFERENTE A EFECTIVO DEBE DE SER POR LA CANTIDAD EXACTA. (DA CLICK PARA DESPARECER ESTA ALERTA) `, timeOut: 99999 });
            return
        }

        switch (Number(PaymentSaleModel.TypeMethod)) {
            case 1: // checks
                if (PaymentSaleModel.PaycheckNum === '') {
                    showAlert({ type: "warning", message: `El campo de cheque esta vació` });
                    return
                }
                if (PaymentSaleModel.BankCode === '') {
                    showAlert({ type: "warning", message: `No has seleccionado un banco para el pago con cheque` });
                    return
                }
                //#region Flujo de caja
                if (Sections['FlujoCaja'] && PaymentSaleModel?.needCheckCFW && !PaymentSaleModel?.checkCFWId && false) { // Este se queda comentado por que en sap no se muestra visualmente
                    showAlert({ type: "warning", message: `Por favor especifique el "Flujo de caja" para cheques`, timeOut: 5000 });
                    return
                }
                //#endregion Flujo de caja
                break;
            case 2: //credit cards

                if (!FlagPayWithSantander || !isSantanderCard) {
                    if (PaymentSaleModel.CardNum === '') {
                        showAlert({ type: "warning", message: `El número de tarjeta esta vació` });
                        return
                    }
                    if (PaymentSaleModel.VoucherNum === '') {
                        showAlert({ type: "warning", message: `El número de autorización esta vació` });
                        return
                    }
                    if (PaymentSaleModel.CardValid.length < 5) {
                        showAlert({ type: "warning", message: `La fecha de vencimiento de la tarjeta esta incompleta` });
                        return
                    }
                } else {
                    LaunchPaymentWithTerminalQuestion();
                    return;
                }
                break;
            case 3://transfers
                if (PaymentSaleModel.TransferNum === '') {
                    showAlert({ type: "warning", message: `El número de transferencia esta vació` });
                    return
                }
                if (PaymentSaleModel.PayAccountNum === '') {
                    showAlert({ type: "warning", message: `El número de cuenta de pago esta vació` });
                    return
                }
                //#region Flujo de caja
                if (Sections['FlujoCaja'] && PaymentSaleModel?.needTransferCFW && !PaymentSaleModel?.transferCFWId) {
                    showAlert({ type: "warning", message: `Por favor especifique el "Flujo de caja" para transferencia`, timeOut: 5000 });
                    return
                }
                //#endregion Flujo de caja
                break;
            case 4://devolution
                if (PaymentSaleModel.ReturnFolio === '') {
                    showAlert({ type: "warning", message: `El folio esta vació` });
                    return
                }
                if (Number(PaymentSaleModel.Amount) > Number(ReturnFolioAmount)) {
                    showAlert({ type: "warning", message: `No puedes tomar un monto mayor al disponible.` });
                    return
                }
                PaymentSaleModel.AvailableAmount = ReturnFolioAmount;


                break;
            case 117://facturas de anticipo
                if (!PaymentSaleModel.auxObjDP.U_FMB_FolioCounter || PaymentSaleModel.auxObjDP.U_FMB_FolioCounter === '') {
                    return showAlert({ type: "error", message: `No has seleccionado una factura de anticipo` });
                }
                if (Number(PaymentSaleModel.Amount) > PaymentSaleModel.auxObjDP.BaseAmnt) {
                    return showAlert({ type: "error", message: `Ingrese un monto menor o igual al saldo pendiente de la factura de anticipo` });
                }
                PaymentSaleModel.PM_Name += ' - ' + PaymentSaleModel.auxObjDP.U_FMB_FolioCounter || 'XXXXXXXX';
                PaymentSaleModel.AmountDP = Number(PaymentSaleModel.Amount);
                break;
            case 14://Nota de crédito
                if (!PaymentSaleModel.DocEntryCN || PaymentSaleModel.DocEntryCN === '') {
                    showAlert({ type: "error", message: `No has seleccionado una nota de crédito` });
                    return
                }
                if (Number(PaymentSaleModel.Amount) > PaymentSaleModel.auxObjCN.DocTotal) {
                    showAlert({ type: "error", message: `No puedes aumentar el valor de una Nota de crédito registrada` });
                    return
                }
                break;
            case -1://Crédito
                if (Number(PaymentSaleModel.Amount) > newOrderModel.Credit) {
                    showAlert({ type: "error", message: `Crédito excedido` });
                }
                newOrderModel.AvailableCredit = newOrderModel.Credit - Number(PaymentSaleModel.Amount);
                break;
            case 555://MONEDERO ELECTRÓNICO
                // if (PaymentSaleModel.puntosADescontar === 0) {
                //     showAlert({ type: "error", message: `Los artículo(s) no cumplen con las condiciones para pagar con puntos` });
                //     return;
                // }
                if (!PaymentSaleModel.puntosADescontar) {
                    showAlert({ type: "error", message: `No has seleccionado pagar con puntos` });
                    return;
                }
                // for (const item of newOrderModel.Items) {
                //     if (item.ItmsGrpCod === ItemsGroupEWallet) {
                //         if (Number(item.Amount)) {
                //             item.DiscountPercentOriginal = Number(item.DiscountPercent).toFixed(4);
                //             item.DiscountPercent += this.GetPercentDiscount(item.TaxeRate, item.Total, item.Amount);
                //             if (item.DiscountPercent > 100) { item.DiscountPercent = 100; }
                //         }
                //     }
                // }
                // RefreshTotal(newOrderModel);
                break;
            case 125: // NIUBIZ
                const qrResponse = await this.generateQR(PaymentSaleModel);

                if (!qrResponse.imageSource) return;
                PaymentSaleModel.idNiubiz = qrResponse.idNiubiz || "";
                PaymentSaleModel.imageSource = qrResponse.imageSource || "";
                break;
            case 0:
                //#region Flujo de caja
                if (Sections['FlujoCaja'] && PaymentSaleModel?.needCashCFW && !PaymentSaleModel?.cashCFWId) {
                    showAlert({ type: "warning", message: `Por favor especifique el "Flujo de caja" para efectivo`, timeOut: 5000 });
                    return
                }
                //#endregion Flujo de caja
                break;
            default:
                break;
        }

        if (Number(PaymentSaleModel.TypeMethod) === 124) {
            PaymentSaleModel.TransferNum = PaymentSaleModel.U_FMB_FISE_COD || '';
        }

        if (needTransferReference(PaymentSaleModel, true)) {
            showAlert({ type: "warning", message: `Debe especificar una referencia${PaymentSaleModel.PM_Name ? ` para la forma de pago "${PaymentSaleModel.PM_Name}"` : ''}.`, timeOut: 8000 });
            return;
        }

        let newArray = newOrderModel.PaymentsToSale;
        newArray.push(PaymentSaleModel);
        newOrderModel.PaymentsToSale = newArray;

        const fisePayments = newArray.filter(({ TypeMethod }) => Number(TypeMethod) === 124);
        if (fisePayments.length) {
            newOrderModel.U_RML_ID_FSE_APP = fisePayments.map(({ ID_FISE_APP }) => ID_FISE_APP).join(",") || "";
            newOrderModel.U_RML_ID_FSE_UDO = fisePayments.map(({ ID_FISE_UDO }) => ID_FISE_UDO).join(",") || "";
            newOrderModel.U_RML_FSE_MONTO = fisePayments.reduce((total, { Amount }) => total + Number(Amount), 0);
            newOrderModel.U_RML_FSE_CODVALE = fisePayments.map(({ U_FMB_FISE_COD }) => U_FMB_FISE_COD).join(",") || "";
        } else {
            newOrderModel.U_RML_ID_FSE_APP = null;
            newOrderModel.U_RML_ID_FSE_UDO = null;
            newOrderModel.U_RML_FSE_MONTO = null;
            newOrderModel.U_RML_FSE_CODVALE = null;
        }
        await RefreshOrder(newOrderModel);
        this.RefreshPaymentSaleModel(auxPaymentSaleModel);
        if (Number(PaymentSaleModel.TypeMethod) === 117) {
            await RefreshTotal(newOrderModel);
            await this.AffectSubTotal(newArray.filter(({ TypeMethod }) => Number(TypeMethod) === 117));
        }
        this.SumOfAmounts();
        clearFise();
        AddPay();
    }

    addingPaymentSaleDeilvery = async () => {
        const { RefreshOrder, newOrderModel, ValidateDelivery } = this.props;

        // if (paymentSelected) {
        // let auxPaymentSaleModel = new PayMethodCounter();
        // let newArray = newOrderModel.PaymentsToSale;
        // newArray.push(PaymentSaleModel);
        // newOrderModel.PaymentsToSale = newArray;
        newOrderModel.PaymentsToSale = [];
        await RefreshOrder(newOrderModel);
        // this.RefreshPaymentSaleModel(auxPaymentSaleModel);
        this.SumOfAmounts();
        await ValidateDelivery();
        paymentSelected = false;
        // } 
        // else {
        //     showAlert({ type: 'info', message: 'NO SE HA SELECCIONADO NINGUNA FORMA DE PAGO' });
        // }
    }

    CleanInfo = async () => {
        const { RefreshOrder, newOrderModel } = this.props;
        newOrderModel.PaymentsToSale = [];
        await RefreshOrder(newOrderModel);
    }

    RemovePaymentSale = async (indexPayment) => {
        const { RefreshOrder, newOrderModel, RefreshTotal, ItemsGroupEWallet } = this.props;
        let newPagos = [];
        let flagDP = false;
        if (Number(newOrderModel.PaymentsToSale[indexPayment].TypeMethod) === -1) {
            newOrderModel.AvailableCredit += Number(newOrderModel.PaymentsToSale[indexPayment].Amount);
        }

        for (let index = 0; index < newOrderModel.PaymentsToSale.length; index++) {
            const pagos = newOrderModel.PaymentsToSale[index];
            if (indexPayment === index && pagos.TypeMethod === '117') { flagDP = true; }
            // if (indexPayment === index && Number(pagos.TypeMethod) === 555) {
            //     for (const item of newOrderModel.Items) {
            //         if (item.ItmsGrpCod === ItemsGroupEWallet) {
            //             if (Number(item.Amount)) {
            //                 item.DiscountPercent = Number(item.DiscountPercentOriginal);
            //                 if (item.DiscountPercent < 0) { item.DiscountPercent = 0; }
            //             }
            //         }
            //     }
            //     RefreshTotal(newOrderModel);
            // }
            if (indexPayment !== index) {
                newPagos.push(pagos);
            }
        }
        newOrderModel.PaymentsToSale = newPagos;
        await RefreshOrder(newOrderModel);
        if (flagDP) {
            RefreshTotal(newOrderModel);
            await this.AffectSubTotal(newPagos.filter(({ TypeMethod }) => Number(TypeMethod) === 117));
        }
        await this.SumOfAmounts();
    }

    RemovePaymentSaleByNiubiz = async (idNiubiz = '') => {
        const { RefreshOrder, newOrderModel } = this.props;
        let newPagos = [];
        for (let index = 0; index < newOrderModel.PaymentsToSale.length; index++) {
            const pagos = newOrderModel.PaymentsToSale[index];
            if (pagos.idNiubiz !== idNiubiz) {
                newPagos.push(pagos);
            }
        }

        newOrderModel.PaymentsToSale = newPagos;
        await RefreshOrder(newOrderModel);
        await this.SumOfAmounts();
    };

    addNiubizReference = async (idNiubiz = '', NiubizReference = '') => {
        const { RefreshOrder, newOrderModel } = this.props;
        if (!idNiubiz || !NiubizReference) return;

        let newPagos = [];
        for (let index = 0; index < newOrderModel.PaymentsToSale.length; index++) {
            const pagos = newOrderModel.PaymentsToSale[index];
            if (pagos.idNiubiz === idNiubiz) {
                newPagos.push({
                    ...pagos,
                    TransferNum: NiubizReference || ''
                });
            } else {
                newPagos.push(pagos);
            }
        }

        newOrderModel.PaymentsToSale = newPagos;
        await RefreshOrder(newOrderModel);
        await this.SumOfAmounts();
    };
    //#endregion

    //#region ########## NIUBIZ ##########
    generateQR = async (paymentInfo) => {
        const { enableSpinner, showAlert } = this.props;
        const data = {
            param: [
                { name: "transactionAmount", value: Number(paymentInfo.Amount || 0) },
                { name: "transactionCurrency", value: "604" }
            ],
        };

        enableSpinner(true)
        const apiResponse = await apiClient.generateNiubizQR(data);
        enableSpinner(false)

        if (apiResponse.status === 1) {
            paymentInfo.idNiubiz = apiResponse?.data?.tagId || "";
            paymentInfo.imageSource = apiResponse?.data?.tagImg || "";

            await this.setState({ currPayment: JSON.parse(JSON.stringify(paymentInfo)), showNiubizModal: true });
            $("#niubizModal").modal("show");
            $("#niubizModal").on("hidden.bs.modal", async () => { await this.setState({ showNiubizModal: false }); });
        } else { showAlert({ type: 'error', message: apiResponse.message || "Ocurrió un error al conectar con el servidor, vuelva a intentar en unos minutos" }); }

        return paymentInfo;
    }
    //#endregion

    findInName(word, name) {
        const response = name.toUpperCase().includes(word)
        return (response)
    }

    ChangeFiseCode = async (value) => {
        const { PaymentSaleModel } = this.props;
        PaymentSaleModel.U_FMB_FISE_COD = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };
    getFiseInfoByCode = async (code) => {
        const { getFiseInfoByCode, showAlert, newOrderModel, FISE } = this.props
        const hasFise = newOrderModel.PaymentsToSale.filter((payment) => payment.TypeMethod === '124');
        if (hasFise.length) {
            if (hasFise.length >= 2) return showAlert({ type: 'warning', message: 'Solo puedes usar este método de pago 2 veces por operación', timeOut: 2000 });
            else if (hasFise.find(({ U_FMB_FISE_COD }) => U_FMB_FISE_COD === code)) return showAlert({ type: 'warning', message: 'Ya se ha agregado este vale en esta operación', timeOut: 2000 });
        }
        if (!code) {
            return showAlert({ type: 'warning', message: 'Ingresa un valor', timeOut: 2000 });
        }
        await getFiseInfoByCode(code)
    }
    openFiseCodes = async () => {
        const { PaymentSaleModel, newOrderModel, enableSpinner, showAlert } = this.props
        this.setState({
            listFise: [],
            showFiseModal: false,
        }, () => {
            $("#fiseModal").modal("hide");
        })
        const search = {
            CardCode: newOrderModel.CardCode,
            Search: PaymentSaleModel?.U_FMB_FISE_COD ?? ''
        }
        enableSpinner(true)
        const apiResponse = await apiClient.listFiseCodes(search);
        enableSpinner(false)
        if (apiResponse?.status == 1) {
            this.setState({
                listFise: apiResponse?.data ?? [],
                showFiseModal: true,
            }, () => {
                $("#fiseModal").modal("show");
            })
        } else {
            showAlert({ type: 'error', message: apiResponse.message || "No se encontraron resultados" });
        }
    }

    selectFiseCode = (value) => {
        this.ChangeFiseCode(value?.U_fise_codigo ?? '')
        this.getFiseInfoByCode(value?.U_fise_codigo ?? '');
        this.setState({ showFiseModal: false, listFise: [] })
        $("#fiseModal").modal("hide");
    }
    validateVoucher = async () => {
        const { PaymentSaleModel, newOrderModel, enableSpinner, showAlert, toleranceInfo = [] } = this.props;
        const payment = newOrderModel.PaymentsToSale.find(payment => ![14, 117].includes(Number(payment.TypeMethod)));
        if (payment && (payment.currency || 'PEN') !== PaymentSaleModel.currency) {
            return showAlert({ type: 'warning', message: 'Todas las transferencias deben usar la moneda del pago.' });
        }
        if (PaymentSaleModel.currency === 'USD' && (!Number.isFinite(PaymentSaleModel.ChangeRate_1) || PaymentSaleModel.ChangeRate_1 <= 0)) {
            return showAlert({ type: 'warning', message: 'No hay un tipo de cambio válido de USD para hoy.' });
        }
        const voucherRound = newOrderModel.PaymentsToSale.find((payment) => Number(payment.TypeMethod) === 3 && payment.currentCheck);
        if (voucherRound) {
            return showAlert({ type: "warning", message: "Solo puedes usar 1 voucher con redondeo" });
        }
        if (!PaymentSaleModel.number) { return showAlert({ type: "warning", message: "Ingrese un Numero de movimiento valido" }); }
        if (!PaymentSaleModel.bank) { return showAlert({ type: "warning", message: "Ingrese un Banco valido" }); }
        if (!moment(PaymentSaleModel.date || "").isValid()) { return showAlert({ type: "warning", message: "Ingrese una fecha valida" }); }
        if (!PaymentSaleModel.currency) { return showAlert({ type: "warning", message: "Ingrese una moneda valida" }); }
        if (!Number(`${PaymentSaleModel.total || 0}`.replace(/,/g, ""))) { return showAlert({ type: "warning", message: "Ingrese un Total valido" }); }

        const hasOldDocs = PaymentSaleModel.date && moment().diff(moment(PaymentSaleModel.date), 'days') > 3;
        if (hasOldDocs && !PaymentSaleModel.U_RS_CODAPR) { return showAlert({ type: "warning", message: "No puede registrar cobros de documentos con más de 3 días de antigüedad. Ingrese un código de aprobación." }); }
        //#region VALIDACIÓN REDONDEO
        if (PaymentSaleModel.currentCheck) {
            const round2 = (value) =>
                Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;
            const total = Number(String(PaymentSaleModel.total ?? 0).replace(/,/g, '')) * (PaymentSaleModel.ChangeRate_1 || 1);
            const remaining = Number(PaymentSaleModel?.totalRemaining ?? 0) -
                Number(total)
            const restante = round2(
                remaining
            );

            const currency = CURRENCY; // Desde counter solo se crea en esta moneda
            const currentTolerance = toleranceInfo?.find(t => t.CurrCode === currency || t.DocCurrCod === currency || t.ISOCurrCod === currency) ?? {};
            const TOLERANCE = restante > 0
                ? Number(currentTolerance?.MaxOutDiff ?? 0) // Falta
                : Number(currentTolerance?.MaxInDiff ?? 0); // Sobra

            if (Math.abs(restante) > TOLERANCE) {

                return showAlert({
                    type: "warning",
                    message: `El depósito supera la tolerancia permitida. Restante: ${(Math.abs(restante))}`
                });

            }
        }

        //#endregion

        enableSpinner(true)
        const apiResponse = await apiClient.validateVoucher({ voucher: PaymentSaleModel });
        enableSpinner(false)
        if (apiResponse.status !== SERVICE_RESPONSE.SUCCESS) {
            return showAlert({ type: "error", message: apiResponse.message || "Error al conectar con el servidor, intente más tarde" });
        }



        this.RefreshPaymentSaleModel(PaymentSaleModel);
        const findVoucher = newOrderModel.PaymentsToSale?.find((payment) => // El quiebre es por todos los siguientes datos, ya que un número de referencia con el mismo monto, moneda y banco puede estar en 2 depositos pero con fechas diferentes
            Number(payment.TypeMethod) === 3 &&
            payment.PayAccountNum === PaymentSaleModel.number &&
            payment.bank === PaymentSaleModel.bank &&
            moment(payment.date).format("YYYY-MM-DD") === moment(PaymentSaleModel.date).format("YYYY-MM-DD") &&
            payment.currency === PaymentSaleModel.currency &&
            parseFloat(String(payment.total ?? 0).replace(/,/g, '')) === parseFloat(String(PaymentSaleModel.total ?? 0).replace(/,/g, ''))
        );
        if (findVoucher) {
            return showAlert({ type: "error", message: 'Ya estas usando este voucher' });
        } else {
            PaymentSaleModel.PayAccountNum = PaymentSaleModel.number
            PaymentSaleModel.Amount = Number((Number(String(PaymentSaleModel.total ?? 0).replace(/,/g, '')) * (PaymentSaleModel.ChangeRate_1 || 1)).toFixed(2));
            await this.addingPaymentSale()
        }

        // voucherList.push({ ...apiResponse.data, operations: [] });
        // setDefaultValues();
    };

    onChangeVoucher = (key, value) => {
        const { PaymentSaleModel, newOrderModel, showAlert } = this.props;
        if (key === 'currency') {
            if (newOrderModel.PaymentsToSale.some(payment => ![14, 117].includes(Number(payment.TypeMethod)))) return;
            const rate = value === 'USD' ? this.props.currencyRate : 1;
            if (!Number.isFinite(rate) || rate <= 0) {
                return showAlert({ type: 'warning', message: 'No hay un tipo de cambio válido de USD para hoy.' });
            }
            const amount = PaymentSaleModel.totalOriginal ?? Number(String(PaymentSaleModel.total ?? 0).replace(/,/g, '')) * (PaymentSaleModel.ChangeRate_1 || 1);
            PaymentSaleModel.totalOriginal = amount;
            PaymentSaleModel.total = Number((amount / rate).toFixed(2));
            PaymentSaleModel.ChangeRate_1 = rate;
            PaymentSaleModel.ifChangeRate = value === 'USD';
        } else if (key === 'total') {
            const amount = Number(String(value).replace(/,/g, ''));
            if (amount !== Number(String(PaymentSaleModel.total ?? 0).replace(/,/g, '')) || PaymentSaleModel.totalOriginal == null) {
                PaymentSaleModel.totalOriginal = amount * (PaymentSaleModel.ChangeRate_1 || 1);
            }
        }
        PaymentSaleModel[key] = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);

    }

    changeCFW = async (event = null, type = 1) => {
        const { PaymentSaleModel } = this.props;
        const value = event?.value ?? event?.nativeEvent?.target?.value ?? null;
        const cfwFields = {
            1: 'transferCFWId',
            2: 'cashCFWId',
            3: 'checkCFWId'
        };
        PaymentSaleModel[cfwFields[type]] = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    render() {
        const {
            CloseBillModal,
            newOrderModel,
            ValidateDocument,
            CancelPayment,
            AvailablePayments,
            PaymentSaleModel,
            BankAccounts,
            CreateDocument,
            addingPay,
            AddPay,
            DownPayments,
            CreditNotes,
            Print,
            SearchReturnFolioAmount,
            ReturnFolioAmount,
            requireInvoice,
            _user,
            creditPay,
            creditNotesPay,
            RelatedPayMethodsByDoc,
            disableRecover,
            ItsRecoverAuthoriInvoice,
            FlagPayWithSantander = false,
            FISE,
            showAlert,
            bankOptions = [],
        } = this.props;

        const { showNiubizModal, currPayment, listFise, showFiseModal, selectedFise } = this.state;
        AvailablePayments.sort((a, b) => (a.type > b.type) ? 1 : ((b.type > a.type) ? -1 : 0));

        let downPaymentAUX = {
            idPMBO: 117,
            name: 'Factura anticipo',
            idAPMBO: '',
            type: '117',
            AcctCode: '',
        }

        let creditNotePaymentAUX = {
            idPMBO: 31,
            name: 'NOTA DE CRÉDITO',
            idAPMBO: '',
            type: '14',
            AcctCode: '',
        }

        let creditPaymentAUX = {
            idPMBO: -1,
            name: 'CRÉDITO',
            idAPMBO: '',
            type: '-1',
            AcctCode: '',
        }

        let paymentPoints = {
            idPMBO: 555,
            name: 'MONEDERO ELECTRÓNICO',
            idAPMBO: '',
            type: '555',
            AcctCode: '',
        }

        const creditCondition = noCreditGroupNumbers.find((GroupNum) => GroupNum === Number(newOrderModel.GroupNum));
        const noDevolutionPMCondition = (requireInvoice || ItsRecoverAuthoriInvoice || newOrderModel.ObjType === 'invoiceReserve' || newOrderModel.isDeliveryInvoice);
        const isSantanderCard = this.findInName("SANTANDER", PaymentSaleModel.PM_Name) ?? false;
        const isSelectedPointsCard = newOrderModel.PaymentsToSale.find((payment) => payment.TypeMethod === '555');
        const isDifferentPointsCard = newOrderModel.PaymentsToSale.some((payment) => payment.TypeMethod !== '555');
        const hasMonedero = newOrderModel.Items.some(item => item.U_FMB_VentaMonedero === 'Y');
        const onlyPointsPayment = newOrderModel.Items.some(item => item.U_FMB_ArtPromo === 'Y');
        const currencyPayment = newOrderModel.PaymentsToSale.find(payment => ![14, 117].includes(Number(payment.TypeMethod)));
        const isUSD = currencyPayment?.currency === 'USD' || (Number(PaymentSaleModel.TypeMethod) === 3 && PaymentSaleModel.currency === 'USD');
        const paymentRate = isUSD ? currencyPayment?.ChangeRate_1 || PaymentSaleModel.ChangeRate_1 || this.props.currencyRate : 1;

        const mapCFWOptions = (options = []) =>
            options.map(cfw => ({
                value: cfw.CFWId,
                label: `${cfw.CFWId} - ${cfw.CFWName}`
            }));

        const transferCFWOptions = !Sections['FlujoCaja'] || addingPay !== true ? [] : mapCFWOptions(PaymentSaleModel?.transferCFWOptions ?? []);
        const cashCFWOptions = !Sections['FlujoCaja'] || addingPay !== true ? [] : mapCFWOptions(PaymentSaleModel?.cashCFWOptions ?? []);
        const checkCFWOptions = !Sections['FlujoCaja'] || addingPay !== true ? [] : mapCFWOptions(PaymentSaleModel?.checkCFWOptions ?? []);

        return (

            <div>
                {newOrderModel.ObjType === 'deliveries2' ?
                    <div className="modal fade" id="billModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="billModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <form>

                                        <div className="">
                                            <h3 className="title">Forma de pago</h3>
                                            <div className="row mt-2 pr-2" style={{ fontSize: "larger" }}>
                                                <div className='pl-4 col-12'>
                                                    <input
                                                        type="text"
                                                        className="form-control "
                                                        placeholder="Buscar método de pago: "
                                                        id="paymentSearch"
                                                        onKeyUp={() => this.DoSearch("payments", "paymentSearch")}
                                                    />
                                                    <div className='card text-center mt-3' style={{ boxShadow: "none", maxHeight: "306px", minHeight: "306px", overflowY: "scroll" }}>
                                                        <table id="payments">
                                                            <tbody>
                                                                {AvailablePayments && AvailablePayments.length > 0 &&
                                                                    AvailablePayments.map((payMethod, index) => {
                                                                        return (
                                                                            <tr key={index} className='m-1' style={{ boxShadow: "none" }}>
                                                                                <td>
                                                                                    <input
                                                                                        className='ml-2 mr-2'
                                                                                        type="radio"
                                                                                        style={{ width: "50px" }}
                                                                                        name='payments'
                                                                                        // checked={PaymentSaleModel.idPMBO === payMethod.idPMBO ? true : false}
                                                                                        onChange={() => this.ChangeTypePayMethod(payMethod)}
                                                                                        disabled={isUSD && Number(payMethod.type) !== 3}
                                                                                    />
                                                                                </td>
                                                                                <td className='p-1 text-center'>
                                                                                    <i className={
                                                                                        this.findInName("EFECTIVO", payMethod.name) ? "fa fa-money" :
                                                                                            // this.findInName("TARJ",payMethod.name)?"fa fa-credit-card":
                                                                                            this.findInName("CHEQUE", payMethod.name) ? "fa fa-keyboard-o" :
                                                                                                this.findInName("TRANS", payMethod.name) ? "fa fa-exchange" :
                                                                                                    this.findInName("CRÉDITO", payMethod.name) ? "fa fa-credit-card" :
                                                                                                        this.findInName("CREDITO", payMethod.name) ? "fa fa-credit-card" :
                                                                                                            this.findInName("DÉBITO", payMethod.name) ? "fa fa-credit-card" :
                                                                                                                this.findInName("DÉBITO", payMethod.name) ? "fa fa-credit-card" :
                                                                                                                    this.findInName("DEVOLUCIÓN", payMethod.name) ? "fa fa-refresh" :
                                                                                                                        this.findInName("FISE", payMethod.name) ? "fa fa-money" :
                                                                                                                            this.findInName("QR", payMethod.name) ? "fa fa-qrcode" :
                                                                                                                                ""
                                                                                    }
                                                                                        aria-hidden="true"
                                                                                        style={{ margin: "1rem" }}
                                                                                    />
                                                                                </td>
                                                                                <td className='p-1 text-left' style={{ fontSize: "15px" }}> {payMethod.name.toUpperCase() || ''}</td>

                                                                            </tr>
                                                                        )
                                                                    })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </form>
                                </div>
                                <div className="modal-footer">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-6 col-sm-4 mb-2 mb-sm-0">
                                                <button type="button" className="btn btn-secondary btn-block btn-lg" data-dismiss="modal" onClick={CancelPayment}>
                                                    Cancelar
                                                </button>
                                            </div>
                                            <div className="col-6 col-sm-8">
                                                <button className="btn btn-primary btn-block btn-lg" type="submit" data-toggle="modal" onClick={this.addingPaymentSaleDeilvery}>
                                                    Continuar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="modal fade" id="billModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="billModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <form>
                                        <div className="mb-2">
                                            {PaymentSaleModel && (Number(PaymentSaleModel.TypeMethod) === 117) && addingPay === true ?
                                                <>
                                                    <h3 className="title">Subtotal: </h3>
                                                    <div className="card row " style={{ fontSize: "xx-large", background: "#00800012", border: "none", boxShadow: "1px 1px 5px rgb(0 0 0 / 0%)" }}>
                                                        <div className=" text-center col-12 pb-2" >
                                                            <span style={{ color: "cornflowerblue" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(newOrderModel.Subtotal)}</span>
                                                        </div>
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    <h3 className="title">Total a pagar: </h3>
                                                    <div className="card row " style={{ fontSize: "xxx-large", background: "#00800012", border: "none", boxShadow: "1px 1px 5px rgb(0 0 0 / 0%)" }}>
                                                        <div className=" text-center col-12 pb-2" >
                                                            <span style={{ color: "green" }}>{(isUSD ? 'USD' : CURRENCY) + ' ' + FORMAT_NUMBER.new(newOrderModel.Total / (paymentRate || 1))}</span>
                                                            {isUSD &&
                                                                <div style={{ fontSize: 'large' }}>
                                                                    {CURRENCY} {FORMAT_NUMBER.new(newOrderModel.Total)} · Tasa: {paymentRate}
                                                                </div>
                                                            }
                                                            <div style={{ fontSize: 'large' }}>Restante: {isUSD ? 'USD' : CURRENCY} {FORMAT_NUMBER.new(newOrderModel.RemainingAmount / (paymentRate || 1))}</div>
                                                        </div>
                                                    </div>
                                                </>
                                            }

                                        </div>
                                        <div className="w-100">
                                            <h3 className="title">Forma de pago</h3>
                                            {addingPay !== true &&
                                                <div className="row mt-4 pr-2">
                                                    <div className='pl-4 col-12'>
                                                        <button type="button" className="form-control btn btn-primary" onClick={AddPay}>
                                                            {/* <i className="fa fa-plus-circle mr-2" aria-hidden="true"/> */}
                                                            Agregar pago
                                                        </button>
                                                    </div>
                                                </div>
                                            }
                                            {addingPay === true && newOrderModel.PaymentsToSale.length > 0 &&
                                                <div className="row mt-4 pr-2">
                                                    <div className='pl-4 col-12'>
                                                        <button type="button" className="form-control btn btn-secondary" onClick={AddPay}>
                                                            {/* <i className="fa fa-plus-circle mr-2" aria-hidden="true"/> */}
                                                            Lista de pagos
                                                        </button>
                                                    </div>
                                                </div>
                                            }
                                            {addingPay === true && (!RelatedPayMethodsByDoc || RelatedPayMethodsByDoc.length === 0) &&
                                                <div className="row mt-2 pr-2" style={{ fontSize: "larger" }}>
                                                    <div className='pl-4 col-12'>
                                                        <input
                                                            type="text"
                                                            className="form-control "
                                                            placeholder="Buscar método de pago: "
                                                            id="paymentSearch"
                                                            onKeyUp={() => this.DoSearch("payments", "paymentSearch")}
                                                        />
                                                        <div className='card text-center mt-3' style={{ boxShadow: "none", maxHeight: "130px", minHeight: "166px", overflowY: "scroll" }}>
                                                            <table id="payments">
                                                                <tbody>
                                                                    {requireInvoice && ((newOrderModel.flagPointsCard)) && newOrderModel.totalPoints !== 0 && !isSelectedPointsCard && (hasMonedero || onlyPointsPayment) &&
                                                                        <tr className='m-1' style={{ boxShadow: "none" }}>
                                                                            <td>
                                                                                <input
                                                                                    className='ml-2 mr-2'
                                                                                    type="radio"
                                                                                    style={{ width: "50px" }}
                                                                                    name='payments'
                                                                                    onChange={() => this.ChangeTypePayMethod(paymentPoints)}
                                                                                    disabled={isDifferentPointsCard || isUSD}
                                                                                />
                                                                            </td>
                                                                            <td className='p-1 text-center'>
                                                                                <i className="fa fa-gift" aria-hidden="true" style={{ margin: "1rem" }} />
                                                                            </td>
                                                                            <td className='p-1 text-left' style={{ fontSize: "15px" }}>
                                                                                <strong>MONEDERO ELECTRÓNICO</strong>
                                                                            </td>
                                                                        </tr>
                                                                    }
                                                                    {((!disableRecover && DownPayments && DownPayments.length > 0) || (DownPayments && DownPayments.length > 0 && ItsRecoverAuthoriInvoice)) && !onlyPointsPayment &&
                                                                        <tr className='m-1' style={{ boxShadow: "none" }}>
                                                                            <td>
                                                                                <input
                                                                                    className='ml-2 mr-2'
                                                                                    type="radio"
                                                                                    style={{ width: "50px" }}
                                                                                    name='payments'
                                                                                    onChange={() => this.ChangeTypePayMethod(downPaymentAUX)}
                                                                                    disabled={isSelectedPointsCard ? true : false}
                                                                                // checked={PaymentSaleModel.idPMBO === 'downPay' ? true : false}
                                                                                />
                                                                            </td>
                                                                            <td className='p-1 text-center'>
                                                                                <i className="fa fa-file-text-o" aria-hidden="true" style={{ margin: "1rem" }} />
                                                                            </td>
                                                                            <td className='p-1 text-left' style={{ fontSize: "15px" }}>
                                                                                <strong>FACTURA DE ANTICIPO</strong>
                                                                            </td>
                                                                        </tr>
                                                                    }
                                                                    {((!disableRecover && CreditNotes && creditNotesPay === true && CreditNotes.length > 0) ||
                                                                        (CreditNotes && creditNotesPay === true && CreditNotes.length > 0 && ItsRecoverAuthoriInvoice) ||
                                                                        (creditNotesPay === true && CreditNotes.length > 0 && newOrderModel.isDeliveryInvoice)
                                                                    ) &&
                                                                        <tr className='m-1' style={{ boxShadow: "none" }}>
                                                                            <td>
                                                                                <input
                                                                                    className='ml-2 mr-2'
                                                                                    type="radio"
                                                                                    style={{ width: "50px" }}
                                                                                    name='payments'
                                                                                    onChange={() => this.ChangeTypePayMethod(creditNotePaymentAUX)}
                                                                                    disabled={isSelectedPointsCard ? true : false}
                                                                                // checked={PaymentSaleModel.idPMBO == 'creditNote' ? true : false}
                                                                                />
                                                                            </td>
                                                                            <td className='p-1 text-center'>
                                                                                <i className="fa fa-file-text-o" aria-hidden="true" style={{ margin: "1rem" }} />
                                                                            </td>
                                                                            <td className='p-1 text-left' style={{ fontSize: "15px" }}>
                                                                                <strong>NOTA DE CRÉDITO</strong>
                                                                            </td>
                                                                        </tr>
                                                                    }
                                                                    {((!disableRecover && creditPay && Number(newOrderModel.CreditLine) > 0 && requireInvoice && newOrderModel.isDeliveryInvoice === false) || // VENTA NORMAL CON LIMITE DE CREDITO SUPERIOR A 0
                                                                        (creditPay && Number(newOrderModel.CreditLine) > 0 && ItsRecoverAuthoriInvoice && newOrderModel.isDeliveryInvoice === false) || //LIMITE DE CREDITO SUPERIOR A 0 Y SI ES RECUPERADA DE AUTORIZACIÓN
                                                                        (Number(newOrderModel.GroupNum) !== -1 && Number(newOrderModel.GroupNum) !== 8 && Number(newOrderModel.GroupNum) !== 0 && requireInvoice && newOrderModel.isDeliveryInvoice === false) || // CONDICION DE PAGO DIFERENTE DE ESOS VALORES
                                                                        (!creditCondition && Number(newOrderModel.CreditLine) > 0 && newOrderModel.ObjType === 'invoiceReserve' && newOrderModel.isDeliveryInvoice === false) //LIMITE DE CREDITO SUPERIOR A 0 Y QUE SEA FACTURA DE RESERVA
                                                                    ) && !onlyPointsPayment && (Number(newOrderModel.GroupNum) !== -1) && // CONDICION DE PAGO DIFERENTE DE ESOS VALORES (-1: CONTADO)
                                                                        <tr className='m-1' style={{ boxShadow: "none" }}>
                                                                            <td>
                                                                                <input
                                                                                    className='ml-2 mr-2'
                                                                                    type="radio"
                                                                                    style={{ width: "50px" }}
                                                                                    name='payments'
                                                                                    onChange={() => this.ChangeTypePayMethod(creditPaymentAUX)}
                                                                                    disabled={isSelectedPointsCard || isUSD}
                                                                                />
                                                                            </td>
                                                                            <td className='p-1 text-center'>
                                                                                <i className="fa fa-file-text-o" aria-hidden="true" style={{ margin: "1rem" }} />
                                                                            </td>
                                                                            <td className='p-1 text-left' style={{ fontSize: "15px" }}>
                                                                                <strong>CRÉDITO</strong>
                                                                            </td>
                                                                        </tr>
                                                                    }

                                                                    {AvailablePayments && AvailablePayments.length > 0 && !onlyPointsPayment &&
                                                                        AvailablePayments.map((payMethod, index) => {
                                                                            if (noDevolutionPMCondition && Number(payMethod?.type ?? '0') === 4) return (<></>)
                                                                            return (
                                                                                <tr key={index} className='m-1' style={{ boxShadow: "none" }}>
                                                                                    <td>
                                                                                        <input
                                                                                            className='ml-2 mr-2'
                                                                                            type="radio"
                                                                                            style={{ width: "50px" }}
                                                                                            name='payments'
                                                                                            // checked={PaymentSaleModel.idPMBO === payMethod.idPMBO ? true : false}
                                                                                            onChange={() => this.ChangeTypePayMethod(payMethod)}
                                                                                            disabled={isSelectedPointsCard || (isUSD && Number(payMethod.type) !== 3)}
                                                                                        />
                                                                                    </td>
                                                                                    <td className='p-1 text-center'>
                                                                                        <i className={
                                                                                            this.findInName("EFECTIVO", payMethod.name) ? "fa fa-money" :
                                                                                                // this.findInName("TARJ",payMethod.name)?"fa fa-credit-card":
                                                                                                this.findInName("CHEQUE", payMethod.name) ? "fa fa-keyboard-o" :
                                                                                                    this.findInName("TRANS", payMethod.name) ? "fa fa-exchange" :
                                                                                                        this.findInName("CRÉDITO", payMethod.name) ? "fa fa-credit-card" :
                                                                                                            this.findInName("CREDITO", payMethod.name) ? "fa fa-credit-card" :
                                                                                                                this.findInName("DÉBITO", payMethod.name) ? "fa fa-credit-card" :
                                                                                                                    this.findInName("DÉBITO", payMethod.name) ? "fa fa-credit-card" :
                                                                                                                        this.findInName("DEVOLUCIÓN", payMethod.name) ? "fa fa-refresh" :
                                                                                                                            this.findInName("FISE", payMethod.name) ? "fa fa-money" :
                                                                                                                                this.findInName("QR", payMethod.name) ? "fa fa-qrcode" :
                                                                                                                                    ""
                                                                                        }
                                                                                            aria-hidden="true"
                                                                                            style={{ margin: "1rem" }}
                                                                                        />
                                                                                    </td>
                                                                                    <td className='p-1 text-left' style={{ fontSize: "15px" }}> {payMethod.name.toUpperCase() || ''}</td>

                                                                                </tr>
                                                                            )
                                                                        })}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {addingPay === true && RelatedPayMethodsByDoc && RelatedPayMethodsByDoc.length > 0 &&
                                                <div className="row mt-2 pr-2" style={{ fontSize: "larger" }}>
                                                    <div className='pl-4 col-12'>
                                                        <input
                                                            type="text"
                                                            className="form-control "
                                                            placeholder="Buscar método de pago: "
                                                            id="paymentSearch"
                                                            onKeyUp={() => this.DoSearch("payments", "paymentSearch")}
                                                        />
                                                        <div className='card text-center mt-3' style={{ boxShadow: "none", maxHeight: "130px", minHeight: "166px", overflowY: "scroll" }}>
                                                            <table id="payments">
                                                                <tbody>
                                                                    {!disableRecover && DownPayments && DownPayments.length > 0 &&
                                                                        <tr className='m-1' style={{ boxShadow: "none" }}>
                                                                            <td>
                                                                                <input
                                                                                    className='ml-2 mr-2'
                                                                                    type="radio"
                                                                                    style={{ width: "50px" }}
                                                                                    name='payments'
                                                                                    onChange={() => this.ChangeTypePayMethod(downPaymentAUX)}
                                                                                />
                                                                            </td>
                                                                            <td className='p-1 text-center'>
                                                                                <i className="fa fa-file-text-o" aria-hidden="true" style={{ margin: "1rem" }} />
                                                                            </td>
                                                                            <td className='p-1 text-left' style={{ fontSize: "15px" }}>
                                                                                <strong>FACTURA DE ANTICIPO</strong>
                                                                            </td>
                                                                        </tr>
                                                                    }

                                                                    {RelatedPayMethodsByDoc && RelatedPayMethodsByDoc.find((payedMethod) => Number(payedMethod.typeMethod) === -1) && CreditNotes && creditNotesPay === true && CreditNotes.length > 0 &&
                                                                        <tr className='m-1' style={{ boxShadow: "none" }}>
                                                                            <td>
                                                                                <input
                                                                                    className='ml-2 mr-2'
                                                                                    type="radio"
                                                                                    style={{ width: "50px" }}
                                                                                    name='payments'
                                                                                    onChange={() => this.ChangeTypePayMethod(creditNotePaymentAUX)}
                                                                                // checked={PaymentSaleModel.idPMBO == 'creditNote' ? true : false}
                                                                                />
                                                                            </td>
                                                                            <td className='p-1 text-center'>
                                                                                <i className="fa fa-file-text-o" aria-hidden="true" style={{ margin: "1rem" }} />
                                                                            </td>
                                                                            <td className='p-1 text-left' style={{ fontSize: "15px" }}>
                                                                                <strong>NOTA DE CRÉDITO</strong>
                                                                            </td>
                                                                        </tr>
                                                                    }

                                                                    {!disableRecover && creditPay && newOrderModel.Credit > 0 && requireInvoice &&
                                                                        <tr className='m-1' style={{ boxShadow: "none" }}>
                                                                            <td>
                                                                                <input
                                                                                    className='ml-2 mr-2'
                                                                                    type="radio"
                                                                                    style={{ width: "50px" }}
                                                                                    name='payments'
                                                                                    onChange={() => this.ChangeTypePayMethod(creditPaymentAUX)}
                                                                                    disabled={isUSD}
                                                                                />
                                                                            </td>
                                                                            <td className='p-1 text-center'>
                                                                                <i className="fa fa-file-text-o" aria-hidden="true" style={{ margin: "1rem" }} />
                                                                            </td>
                                                                            <td className='p-1 text-left' style={{ fontSize: "15px" }}>
                                                                                <strong>CRÉDITO</strong>
                                                                            </td>
                                                                        </tr>
                                                                    }

                                                                    {AvailablePayments && AvailablePayments.length > 0 &&
                                                                        AvailablePayments.map((payMethod, index) => {
                                                                            let flag = false;
                                                                            let auxRelatedPaymethod = null;

                                                                            if (RelatedPayMethodsByDoc && RelatedPayMethodsByDoc.length > 0) {
                                                                                for (let i = 0; i < RelatedPayMethodsByDoc.length; i++) {
                                                                                    const payedMethod = RelatedPayMethodsByDoc[i];
                                                                                    if (payedMethod.typeMethod === payMethod.type /*&& payedMethod.idPMBO === payMethod.idPMBO*/) {
                                                                                        flag = true;
                                                                                        auxRelatedPaymethod = payMethod;
                                                                                    }
                                                                                }
                                                                            }

                                                                            if (auxRelatedPaymethod) {
                                                                                return (
                                                                                    <tr key={index} className={`m-1 ${flag ? 'selectedPayMethod' : ''}`} style={{ boxShadow: "none", display: flag ? '' : 'none' }}>
                                                                                        <td>
                                                                                            <input
                                                                                                className='ml-2 mr-2'
                                                                                                type="radio"
                                                                                                style={{ width: "50px" }}
                                                                                                checked={PaymentSaleModel.idPMBO === payMethod.idPMBO ? true : false}
                                                                                                onChange={() => this.ChangeTypePayMethod(auxRelatedPaymethod)}
                                                                                                disabled={isUSD && ![3, 14, 117].includes(Number(auxRelatedPaymethod.type))}
                                                                                            />
                                                                                        </td>
                                                                                        <td className='p-1 text-center'>
                                                                                            <i className={
                                                                                                this.findInName("EFECTIVO", auxRelatedPaymethod.name) ? "fa fa-money" :
                                                                                                    // this.findInName("TARJ",payMethod.name)?"fa fa-credit-card":
                                                                                                    this.findInName("CHEQUE", auxRelatedPaymethod.name) ? "fa fa-keyboard-o" :
                                                                                                        this.findInName("TRANS", auxRelatedPaymethod.name) ? "fa fa-exchange" :
                                                                                                            this.findInName("CRÉDITO", auxRelatedPaymethod.name) ? "fa fa-credit-card" :
                                                                                                                ""
                                                                                            }
                                                                                                aria-hidden="true"
                                                                                                style={{ margin: "1rem" }}
                                                                                            />
                                                                                        </td>
                                                                                        <td className='p-1 text-left' style={{ fontSize: "15px" }}> {payMethod.name.toUpperCase() || ''}</td>

                                                                                    </tr>
                                                                                )
                                                                            } else {
                                                                                return (<></>)
                                                                            }

                                                                        })}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            }


                                            {/* PAYMETHOD CHEQUE */}
                                            {PaymentSaleModel && (Number(PaymentSaleModel.TypeMethod) === 1) && addingPay === true &&
                                                <>
                                                    <div className="row mt-3 pr-2" style={{ fontSize: "larger" }}>
                                                        <div className="col-3 pl-4">
                                                            <label className="form-label mt-1">Cheque: </label>
                                                        </div>
                                                        <div className="col-3 pl-4">
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                value={PaymentSaleModel.PaycheckNum || ''}
                                                                onChange={(event) => this.ChangePaycheckNum(event.target.value)}
                                                            />
                                                        </div>
                                                        <div className="col-2 pl-4">
                                                            <label className="form-label mt-1">Fecha: </label>
                                                        </div>
                                                        <div className="col-4">
                                                            <input
                                                                className="form-control"
                                                                type="date"
                                                                value={PaymentSaleModel.DatePaycheck || ''}
                                                                max='9999-12-31'
                                                                onChange={(event) => this.ChangeDatePayCheck(event.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mt-2 pr-2" style={{ fontSize: "larger" }}>
                                                        <div className="col-3 pl-4">
                                                            <label className="form-label mt-1">Banco: </label>
                                                        </div>
                                                        <div className="col-9 pl-4">
                                                            <select
                                                                name="select"
                                                                className="form-control"
                                                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                                                value={PaymentSaleModel.BankCode || ''}
                                                                onChange={(event) => this.ChangeBank(event.target.value)}
                                                            >
                                                                <option value="">Seleccionar banco</option>
                                                                {!!BankAccounts && BankAccounts.map(bank => {
                                                                    return (
                                                                        <option value={bank.BankCode}>{`${bank.BankCode} ${bank.BankName}`}</option>
                                                                    )
                                                                })}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                            {/* PAYMETHOD TARJETA */}
                                            {PaymentSaleModel && (Number(PaymentSaleModel.TypeMethod) === 2) && addingPay === true && (!FlagPayWithSantander || !isSantanderCard) &&
                                                <div className="row mt-2 pr-2" style={{ fontSize: "large" }}>
                                                    <div className='pl-4 col-12'>
                                                        <div className="row mt-3" >
                                                            <div className="col-6">
                                                                <label className="form-label mt-1">No. Tarjeta: </label>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    value={PaymentSaleModel.CardNum || ''}
                                                                    onChange={(event) => this.ChangeCardNum(event.target.value)}
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <label className="form-label mt-1">No. Autorización: </label>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    value={PaymentSaleModel.VoucherNum || ''}
                                                                    onChange={(event) => this.ChangeVoucherNum(event.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <label className="form-label mt-1">No. Identificación: </label>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    value={PaymentSaleModel.Indentification || ''}
                                                                    onChange={(event) => this.ChangeIndentification(event.target.value)}
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <label className="form-label mt-1">No. Teléfono: </label>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    value={PaymentSaleModel.PhoneNum || ''}
                                                                    onChange={(event) => this.ChangePhoneNum(event.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <label className="form-label mt-1">Válido hasta: </label>
                                                                <input
                                                                    type=" text"
                                                                    className="form-control btn-outline-secondary"
                                                                    placeholder='MM/AA'
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        borderColor: '#ced4da',
                                                                        color: '#000',
                                                                    }}
                                                                    maxlength="5"
                                                                    value={PaymentSaleModel.CardValid || ''}
                                                                    onChange={(event) => this.ChangeValidCard(event.nativeEvent.target.value)}
                                                                    onBlur={(event) => this.ChangeValidateValidCard()}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {/* PAYMETHOD TRANSFERENCIA */}
                                            {PaymentSaleModel && (Number(PaymentSaleModel.TypeMethod) === 3) && addingPay === true &&
                                                <>
                                                    <div className="modal-body py-3">
                                                        <div className="row px-3">
                                                            <div className="col-12 mb-3 Depositos">
                                                                {/* <span className="ml-auto h5 font-weight-bold Depositos"> Efectivo Total: {CURRENCY} {FORMAT_NUMBER.new(cashTotal)}</span> */}
                                                            </div>

                                                            <div className="col-12 border rounded p-3">
                                                                <div className="row align-items-end">
                                                                    {/* Flujo de caja */}
                                                                    {Sections['FlujoCaja'] &&
                                                                        <div className="col-12 col-md-12">
                                                                            <div className="input-group mb-3">
                                                                                <div className="input-group-prepend">
                                                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Flujo de caja</span>
                                                                                </div>
                                                                                {(
                                                                                    <Select
                                                                                        options={transferCFWOptions}
                                                                                        value={transferCFWOptions?.find(opt => opt.value === PaymentSaleModel?.transferCFWId) || null}
                                                                                        onChange={(event) => addingPay === true && this.changeCFW(event, 1)}
                                                                                        placeholder={addingPay !== true ? '' : "Escribe para buscar"}
                                                                                        isDisabled={addingPay !== true || !PaymentSaleModel?.needTransferCFW}
                                                                                        isSearchable={true}
                                                                                        isClearable={true}
                                                                                        menuPortalTarget={document.body}
                                                                                        noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                                                        styles={{
                                                                                            container: (base) => ({ ...base, flex: 1 }),
                                                                                            control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                                                                            menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                                                            valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                                                                            input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                                                                            singleValue: (base) => ({ ...base, color: "#000" })
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    <div className="col-12 col-md-6">
                                                                        <div className="input-group mb-3">
                                                                            <div className="input-group-prepend">
                                                                                <span className="input-group-text font-weight-bold"> N° Mov </span>
                                                                            </div>
                                                                            <input
                                                                                className="form-control"
                                                                                value={PaymentSaleModel.number || ""}
                                                                                onChange={({ target: { value } }) => {
                                                                                    this.onChangeVoucher('number', `${value || ""}`.slice(0, 20));
                                                                                    this.onChangeVoucher('TransferNum', `${value || ""}`.slice(0, 20))
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <div className="input-group mb-3">
                                                                            <div className="input-group-prepend">
                                                                                <span className="input-group-text font-weight-bold"> Banco </span>
                                                                            </div>
                                                                            {/* <input
                                                                                className="form-control"
                                                                                value={PaymentSaleModel.bank || ""}
                                                                                onChange={({ target: { value } }) => {
                                                                                    this.onChangeVoucher('bank', `${value || ""}`.slice(0, 20));
                                                                                }}
                                                                            /> */}
                                                                            <select
                                                                                name="select"
                                                                                className="form-control"
                                                                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                                                                value={PaymentSaleModel.bank || ''}
                                                                                onChange={({ target: { value } }) => {
                                                                                    this.onChangeVoucher('bank', `${value || ""}`.slice(0, 20));
                                                                                }}
                                                                            >
                                                                                <option value="">Seleccionar</option>
                                                                                {!!bankOptions && bankOptions?.map(bank => {
                                                                                    return (
                                                                                        <option value={bank.BankCode}>{bank.BankName || ''}</option>
                                                                                    )
                                                                                })}
                                                                            </select>
                                                                        </div>
                                                                        <div className="input-group mb-3">
                                                                            <div className="input-group-prepend">
                                                                                <span className="input-group-text font-weight-bold"> Fecha </span>
                                                                            </div>
                                                                            <input
                                                                                className="form-control text-right"
                                                                                type="date"
                                                                                value={PaymentSaleModel.date || ""}
                                                                                onChange={({ target: { value } }) => {
                                                                                    this.onChangeVoucher('date', value);
                                                                                    this.onChangeVoucher('DatePaycheck', value)
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <div className="input-group mb-3 mb-md-0">
                                                                            <div className="input-group-prepend">
                                                                                <span className="input-group-text font-weight-bold">#Aprobación</span>
                                                                            </div>
                                                                            <input
                                                                                className="form-control"
                                                                                value={PaymentSaleModel.U_RS_CODAPR || ""}
                                                                                onChange={({ target: { value } }) => {

                                                                                    this.onChangeVoucher('U_RS_CODAPR', `${value || ""}`?.slice(0, 20));
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-12 col-md-6">
                                                                        <div className="input-group mb-3">
                                                                            <div className="input-group-prepend">
                                                                                <span className="input-group-text font-weight-bold"> Moneda </span>
                                                                            </div>
                                                                            <select
                                                                                className="form-control"
                                                                                value={PaymentSaleModel.currency || 'PEN'}
                                                                                disabled={Boolean(currencyPayment)}
                                                                                onChange={({ target: { value } }) => {
                                                                                    this.onChangeVoucher('currency', `${value || ""}`.toLocaleUpperCase().slice(0, 20));
                                                                                }}
                                                                            >
                                                                                <option value="PEN">PEN</option>
                                                                                <option value="USD">USD</option>
                                                                            </select>
                                                                        </div>
                                                                        <div className="input-group mb-3">
                                                                            <div className="input-group-prepend">
                                                                                <span className="input-group-text font-weight-bold"> Monto </span>
                                                                            </div>
                                                                            <input
                                                                                className="form-control text-right"
                                                                                value={PaymentSaleModel.total || ""}
                                                                                onChange={({ target: { value } }) => {
                                                                                    const finalValue = value === "." ? "0."
                                                                                        : isNaN(`${value || ""}`.replace(/,/g, "")) ? PaymentSaleModel.total
                                                                                            : `${value || ""}`.trim()
                                                                                    this.onChangeVoucher('total', finalValue);
                                                                                    // this.onChangeVoucher('Amount', finalValue);
                                                                                }}
                                                                                onBlur={() => {
                                                                                    this.onChangeVoucher('total', FORMAT_NUMBER.new(`${PaymentSaleModel.total || ""}`.replace(/,/g, "")));
                                                                                    // this.onChangeVoucher('Amount', FORMAT_NUMBER.new(`${PaymentSaleModel.total || ""}`.replace(/,/g, "")));

                                                                                }}
                                                                            />
                                                                        </div>

                                                                        <div className="input-group mb-3" >
                                                                            <div className="input-group-prepend">
                                                                                <div className="input-group-text font-weight-bold">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        style={{ transform: 'scale(1.5)', cursor: 'pointer' }}
                                                                                        id={`checkR`}
                                                                                        checked={PaymentSaleModel.currentCheck}
                                                                                        onChange={({ target: { checked } }) => {
                                                                                            this.onChangeVoucher('currentCheck', checked);
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <input
                                                                                className="form-control"
                                                                                id={`inputR`}
                                                                                value={'Redondeo'}
                                                                                readOnly
                                                                            />
                                                                        </div>
                                                                        <div className="d-flex justify-content-end">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-success btnNuevo"
                                                                                style={{ minWidth: 120 }}
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    e.stopPropagation();
                                                                                    this.validateVoucher();
                                                                                }}
                                                                            >
                                                                                <i className="fa fa-plus mr-2" />
                                                                                Agregar
                                                                            </button>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* <div className="col-12 border rounded p-3 my-3 Depositos" style={{ maxHeight: 300, overflow: "auto" }}>
                                                                {voucherList?.length ? voucherList.map(renderDepositCard)
                                                                    : "Sin depositos registrados"}
                                                            </div> */}

                                                            {/* <div className="col-12 col-md-6 col-lg-6 d-flex">
                                                                <span className="ml-auto h5 font-weight-bold Depositos"> Restante: {CURRENCY} {FORMAT_NUMBER.new(((cashTotal - voucherList.reduce((acc, current) => acc += Number(current.Total), 0)) * 100) / 100)}</span>
                                                            </div>
                                                            <div className="col-12 col-md-6 col-lg-6 d-flex">
                                                                <span className="ml-auto h5 font-weight-bold Depositos"> Total: {CURRENCY} {FORMAT_NUMBER.new(voucherList.reduce((acc, current) => acc += Number(current.Total), 0))}</span>
                                                            </div> */}
                                                        </div>
                                                    </div>
                                                    {/* <div className="row mt-2 pr-2" style={{ fontSize: "larger" }}>
                                                        <div className='pl-4 col-12'>
                                                            <div className="row mt-3" >
                                                                <div className="col-6">
                                                                    <label className="form-label mt-1">No. Transferencia: </label>
                                                                    <input
                                                                        className="form-control"
                                                                        type="text"
                                                                        value={PaymentSaleModel.TransferNum || ''}
                                                                        onChange={(event) => this.ChangeTransferNum(event.target.value)}
                                                                    />
                                                                </div>
                                                                <div className="col-6">
                                                                    <label className="form-label mt-1">No. Cuenta de pago: </label>
                                                                    <input
                                                                        className="form-control"
                                                                        type="text"
                                                                        value={PaymentSaleModel.PayAccountNum || ''}
                                                                        onChange={(event) => this.ChangePayAccountNum(event.target.value)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="row" >
                                                                <div className="col-6">
                                                                    <label className="form-label mt-1">Fecha: </label>
                                                                    <input
                                                                        className="form-control"
                                                                        type="date"
                                                                        value={PaymentSaleModel.DatePaycheck || ''}
                                                                        max='9999-12-31'
                                                                        onChange={(event) => this.ChangeDatePayCheck(event.target.value)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                </>
                                            }
                                            {/* PAYMETHOD DEVOLUCION */}
                                            {PaymentSaleModel && (Number(PaymentSaleModel.TypeMethod) === 4) && addingPay === true &&
                                                <>
                                                    <div className="row mt-2 pr-2 pl-2" style={{ fontSize: "larger" }}>
                                                        <div className="col-3">
                                                            <label className="form-label mt-1">Folio: </label>
                                                        </div>
                                                        <div className="col-7">
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                value={PaymentSaleModel.ReturnFolio || ''}
                                                                onChange={(event) => this.ChangeReturnFolio(event.target.value)}
                                                                onKeyPress={(ev) => {
                                                                    if (ev.key === 'Enter') {
                                                                        SearchReturnFolioAmount();

                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="col-1 pl-4">
                                                            <button
                                                                type="button"
                                                                onClick={() => SearchReturnFolioAmount()}
                                                                className="btn btn-primary">
                                                                <i className="fa fa-search" aria-hidden="true" />

                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-2 pr-2 pl-2" style={{ fontSize: "larger" }}>
                                                        <div className="col-5">
                                                            <label className="form-label mt-1">Monto disponible: </label>
                                                        </div>
                                                        <div className="col-7">
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                disabled={true}
                                                                value={ReturnFolioAmount || ''}
                                                            />
                                                        </div>

                                                    </div>
                                                </>
                                            }
                                            {/* PAY METHOD FACTURA ANTICIPO */}
                                            {PaymentSaleModel && (Number(PaymentSaleModel.TypeMethod) === 117) && addingPay === true &&
                                                <>
                                                    <div className="row mt-2 pr-2" style={{ fontSize: "larger" }}>
                                                        <div className='pl-4 col-12'>
                                                            <div className='card text-center mt-3' style={{ boxShadow: "none", maxHeight: "130px", minHeight: "166px", overflowY: "scroll" }}>
                                                                <div>
                                                                    {DownPayments && DownPayments.length > 0 &&
                                                                        DownPayments.map((downPay, index) => {

                                                                            let flag = false;
                                                                            if (newOrderModel.PaymentsToSale && newOrderModel.PaymentsToSale.length > 0) {
                                                                                for (let i = 0; i < newOrderModel.PaymentsToSale.length; i++) {
                                                                                    const payAdded = newOrderModel.PaymentsToSale[i];
                                                                                    if (payAdded.DocEntryDP === downPay.DocEntry) {
                                                                                        flag = true;
                                                                                    }
                                                                                }
                                                                            }
                                                                            const isCredit = Number(newOrderModel.GroupNum) !== -1;
                                                                            const distinctTaxes = [//OBTENER TAX
                                                                                ...new Map(
                                                                                    newOrderModel?.Items?.map(item => [
                                                                                        `${item.TaxeRate}-${item.TaxCode}`,
                                                                                        {
                                                                                            TaxRate: isCredit ? item.TaxeRateCredit : item.TaxeRate,//SI ES CREDITO TOMAR EL VALOR QUE SE LE VA A COBRAR.
                                                                                            TaxCode: isCredit ? item.TaxCodeCredit : item.TaxCode
                                                                                        }
                                                                                    ])
                                                                                ).values()
                                                                            ];
                                                                            if (distinctTaxes.length > 1) {
                                                                                flag = true;
                                                                            }

                                                                            if (Number(downPay.VatPercent || 0) !== Number(distinctTaxes?.[0]?.TaxRate || 0)) {
                                                                                flag = true;
                                                                            }

                                                                            return (
                                                                                <>
                                                                                    <tr className='m-1' style={{ boxShadow: "none", fontSize: "15px" }}>
                                                                                        <td rowSpan="2" className="align-middle">
                                                                                            <input
                                                                                                className='ml-2 mr-2'
                                                                                                type="radio"
                                                                                                style={{ width: "50px" }}
                                                                                                onChange={() => { if (!flag) { this.ChangeDocEntryDP(downPay); } }}
                                                                                                checked={PaymentSaleModel.DocEntryDP === downPay.DocEntry}
                                                                                                disabled={flag} />
                                                                                        </td>
                                                                                        <td>{downPay.DocEntry ?? ''}</td>
                                                                                        <td className='p-1 text-center'>
                                                                                            <strong style={{ color: "black", margin: "1rem" }}>{downPay.U_FMB_FolioCounter ?? 'XXXXXXXX'}</strong>
                                                                                        </td>
                                                                                        <td>{moment(downPay.DocDate).format("YYYY-MM-DD") ?? ''}</td>
                                                                                        <td className='p-1 text-left'>
                                                                                            <strong>{CURRENCY + ' ' + FORMAT_NUMBER.new(downPay.BaseAmnt) ?? ''}</strong>
                                                                                        </td>
                                                                                        {/* <td className='p-1 text-left'>
                                                                                        <strong>{SYMBOL + FORMAT_NUMBER.new(downPay.DocTotal) ?? ''}</strong>
                                                                                    </td> */}
                                                                                    </tr>
                                                                                    <tr className="m-0 p-0" style={{ boxShadow: "none", fontSize: "12px" }}>
                                                                                        <td colSpan="4" className="p-0" style={{ color: !flag ? "green" : "red" }}>
                                                                                            <div className="d-flex">
                                                                                                Tasa de impuesto: {Number(downPay.VatPercent || 0)}%
                                                                                                {flag && <ToolTip tips={[{ message: "La tasa de impuesto no es igual a la tasa del documento actual" }]} position="up" width="200" />}
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                </>
                                                                            )
                                                                        })}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                            {/* PAY METHOD CREDIT NOTES */}
                                            {PaymentSaleModel && (Number(PaymentSaleModel.TypeMethod) === 14) && addingPay === true &&
                                                <>
                                                    <div className="row mt-2 pr-2" style={{ fontSize: "larger" }}>
                                                        <div className='pl-4 col-12'>
                                                            <div className='card text-center mt-3' style={{ boxShadow: "none", maxHeight: "130px", minHeight: "166px", overflowY: "scroll" }}>
                                                                {CreditNotes && CreditNotes.length > 0 &&
                                                                    CreditNotes.map((creditNote, index) => {

                                                                        let flag = false;
                                                                        if (newOrderModel.PaymentsToSale && newOrderModel.PaymentsToSale.length > 0) {
                                                                            for (let i = 0; i < newOrderModel.PaymentsToSale.length; i++) {
                                                                                const payAdded = newOrderModel.PaymentsToSale[i];
                                                                                if (payAdded.DocEntryCN === creditNote.DocEntry) {
                                                                                    flag = true;
                                                                                }
                                                                            }
                                                                        }

                                                                        return (
                                                                            <tr className='m-1' style={{ boxShadow: "none", fontSize: "15px" }}>
                                                                                <td>
                                                                                    <input
                                                                                        className='ml-2 mr-2'
                                                                                        type="radio"
                                                                                        style={{ width: "50px" }}
                                                                                        onChange={() => this.ChangeDocEntryCN(creditNote)}
                                                                                        checked={PaymentSaleModel.DocEntryCN === creditNote.DocEntry}
                                                                                        disabled={flag}
                                                                                    />
                                                                                </td>
                                                                                <td>{creditNote.DocEntry ?? ''}</td>
                                                                                <td className='p-1 text-center'>
                                                                                    <strong style={{ color: "black", margin: "1rem" }}>{creditNote.U_FMB_FolioCounter ?? 'XXXXXXXX'}</strong>
                                                                                </td>
                                                                                <td>{moment(creditNote.DocDate).format("YYYY-MM-DD") ?? ''}</td>
                                                                                <td className='p-1 text-left'>
                                                                                    <strong>{CURRENCY + ' ' + FORMAT_NUMBER.new(creditNote.totalPago) ?? ''}</strong>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                            {/* PAY METHOD CREDIT LINE */}
                                            {PaymentSaleModel && (Number(PaymentSaleModel.TypeMethod) === -1) && addingPay === true &&
                                                <>
                                                    <div className="row mt-2 pr-2" style={{ fontSize: "larger" }}>
                                                        <div className='pl-4 col-12'>
                                                            <div className='card text-center mt-3' style={{ boxShadow: "none", maxHeight: "130px", minHeight: "30px", overflowY: "scroll" }}>
                                                                {newOrderModel.Credit && newOrderModel.Credit > 0 &&
                                                                    <tr className='m-1' style={{ boxShadow: "none", fontSize: "15px" }}>
                                                                        <td className='p-1 text-center'>
                                                                            <strong style={{ color: "black", margin: "1rem" }}>{'Crédito disponible: '}</strong>
                                                                        </td>
                                                                        <td className='p-1 text-left'>
                                                                            <strong>{CURRENCY + ' ' + FORMAT_NUMBER.new(newOrderModel.AvailableCredit) ?? ''}</strong>
                                                                        </td>
                                                                    </tr>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                            {/* POINTS CARD */}
                                            {requireInvoice && PaymentSaleModel && (Number(PaymentSaleModel.TypeMethod) === 555) && addingPay === true &&
                                                <>
                                                    <div className="row mt-2 pr-2" style={{ fontSize: "larger" }}>
                                                        <div className='pl-4 col-12'>
                                                            <div className='card text-center mt-3' style={{ boxShadow: "none", maxHeight: "130px", minHeight: "30px", overflowY: "scroll" }}>
                                                                <tr className='m-1' style={{ boxShadow: "none", fontSize: "15px" }}>
                                                                    <td>
                                                                        <input
                                                                            className='ml-2 mr-2'
                                                                            type="radio"
                                                                            style={{ width: "50px" }}
                                                                            onChange={() => this.ChangeSelectedPointsCard(newOrderModel.totalPoints)}
                                                                            disabled={isDifferentPointsCard}
                                                                        />
                                                                    </td>
                                                                    <td className='p-1 text-center'>
                                                                        <strong style={{ color: "black", margin: "1rem" }}>{'Puntos acumulados: '}</strong>
                                                                    </td>
                                                                    <td className='p-1 text-left'>
                                                                        <strong>{(newOrderModel.totalPoints) ?? 0}</strong>
                                                                    </td>
                                                                </tr>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                            {/* PAYMETHOD FISE */}
                                            {PaymentSaleModel && (Number(PaymentSaleModel.TypeMethod) === 124) && addingPay === true &&
                                                <div className="row mt-3 pr-2 pl-2 w-100 d-flex align-items-center" style={{ fontSize: "larger" }}>

                                                    <div className="col-3 ml-3 p-0 d-flex align-items-center">
                                                        <label className="form-label mb-0">Cód. FISE:</label>
                                                    </div>

                                                    <div className="col-6 p-0 ml-2">
                                                        <input
                                                            placeholder="Ingrese su código FISE"
                                                            className="form-control"
                                                            type="text"
                                                            value={PaymentSaleModel.U_FMB_FISE_COD || ''}
                                                            onChange={(event) => this.ChangeFiseCode(event.target.value)}
                                                        />
                                                    </div>

                                                    <div className="col-1 p-0 ml-2">
                                                        <button
                                                            type="button"
                                                            style={{
                                                                backgroundColor: 'transparent',
                                                                color: '#EABF28',
                                                                border: "1px solid #ced4da"
                                                            }}
                                                            className="btn btn-outline-secondary"
                                                            onClick={() => this.openFiseCodes()}
                                                        >
                                                            <i className="fa fa-search"></i>
                                                        </button>
                                                    </div>

                                                </div>

                                            }

                                            {/* IMPORTE */}
                                            {addingPay === true && Number(PaymentSaleModel.TypeMethod) != 3 &&
                                                <div className="row mt-3 pr-2" style={{ fontSize: "larger" }}>
                                                    {/* Flujo de caja */}
                                                    {(Sections['FlujoCaja'] && Number(PaymentSaleModel?.TypeMethod) === 0) && PaymentSaleModel?.AcctCode &&
                                                        <div className="modal-body py-2 col-12">
                                                            <div className="row px-3">
                                                                <div className="input-group mb-2">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Flujo de caja</span>
                                                                    </div>
                                                                    {(
                                                                        <Select
                                                                            options={cashCFWOptions}
                                                                            value={cashCFWOptions?.find(opt => opt.value === PaymentSaleModel?.cashCFWId) || null}
                                                                            onChange={(event) => addingPay === true && this.changeCFW(event, 2)}
                                                                            placeholder={addingPay !== true ? '' : "Escribe para buscar"}
                                                                            isDisabled={addingPay !== true || !PaymentSaleModel?.needCashCFW}
                                                                            isSearchable={true}
                                                                            isClearable={true}
                                                                            menuPortalTarget={document.body}
                                                                            noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                                            styles={{
                                                                                container: (base) => ({ ...base, flex: 1 }),
                                                                                control: (base) => ({ ...base, height: 40, minHeight: 40, minWidth: 300, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                                                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                                                valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                                                                input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                                                                singleValue: (base) => ({ ...base, color: "#000" })
                                                                            }}
                                                                        />
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                    <div className="col-4 col-md-3 pl-4">
                                                        <label className="form-label mt-1">Importe: </label>
                                                    </div>
                                                    <div className="col-4 col-md-7 pl-4">
                                                        <input
                                                            className="form-control"
                                                            type="number"
                                                            min={0}
                                                            disabled={(Number(PaymentSaleModel.TypeMethod) === -1 || Number(PaymentSaleModel.TypeMethod) === 555) ? true : false}
                                                            value={PaymentSaleModel.Amount ? (PaymentSaleModel.Amount < 0 ? 0 : PaymentSaleModel.Amount) : ''}
                                                            placeholder={PaymentSaleModel.Amount || 0}
                                                            onChange={(event) => this.ChangeAmount(event.nativeEvent.target.value)}
                                                            onKeyPress={(ev) => {
                                                                if (ev.key === 'Enter') {
                                                                    this.addingPaymentSale();

                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-4 col-md-1 pl-4">
                                                        <button
                                                            type="button"
                                                            onClick={() => this.addingPaymentSale()}
                                                            className="btn btn-outline-success">
                                                            <i className="fa fa-plus-circle" aria-hidden="true" />

                                                        </button>
                                                    </div>
                                                </div>
                                            }
                                            {/* MÉTODOS DE PAGO AGREGADOS */}
                                            {addingPay !== true &&
                                                <div className="row mt-2 pr-2" style={{ fontSize: "larger" }}>
                                                    <div className='pl-4 col-12'>
                                                        <div className='card text-center mt-3' style={{ boxShadow: "none", maxHeight: "300px", minHeight: "200px", overflowY: "scroll" }}>
                                                            <table className="table-striped table-hover" id="payments">
                                                                <tbody>
                                                                    {newOrderModel && newOrderModel.PaymentsToSale.length > 0 &&
                                                                        newOrderModel.PaymentsToSale.map((payMethod, index) => {
                                                                            return (
                                                                                <tr key={index} style={{ boxShadow: "none" }}>
                                                                                    <td className='text-center'>
                                                                                        <i className={
                                                                                            this.findInName("EFECTIVO", payMethod.PM_Name) ? "fa fa-money" :
                                                                                                this.findInName("CHEQUE", payMethod.PM_Name) ? "fa fa-keyboard-o" :
                                                                                                    this.findInName("TRANS", payMethod.PM_Name) ? "fa fa-exchange" :
                                                                                                        this.findInName("NOTA ", payMethod.PM_Name) ? "fa fa-file-text-o" :
                                                                                                            this.findInName("CRÉDITO", payMethod.PM_Name) ? "fa fa-credit-card" :
                                                                                                                this.findInName("DÉBITO", payMethod.PM_Name) ? "fa fa-credit-card" :
                                                                                                                    this.findInName("DEBITO", payMethod.PM_Name) ? "fa fa-credit-card" :
                                                                                                                        this.findInName("DEVOLUCIÓN", payMethod.PM_Name) ? "fa fa-refresh" :
                                                                                                                            this.findInName("MONEDERO ELECTRÓNICO", payMethod.PM_Name) ? "fa fa-gift" :
                                                                                                                                this.findInName("FISE", payMethod.PM_Name) ? "fa fa-money" :
                                                                                                                                    this.findInName("QR", payMethod.PM_Name) ? "fa fa-qrcode" :
                                                                                                                                        ""
                                                                                        }
                                                                                            aria-hidden="true"
                                                                                            style={{ margin: "1rem" }}
                                                                                        />
                                                                                    </td>

                                                                                    <td className='p-1 col-sm-auto text-left' style={{ fontSize: 'initial' }}>
                                                                                        {
                                                                                            this.findInName("EFECTIVO", payMethod.PM_Name) ? "EFECTIVO" :
                                                                                                this.findInName("CHEQUE", payMethod.PM_Name) ? "CHEQUE" :
                                                                                                    this.findInName("TRANS", payMethod.PM_Name) ? "TRANSFERENCIA" :
                                                                                                        this.findInName("NOTA", payMethod.PM_Name) ? "NOTA DE CRÉDITO" :
                                                                                                            this.findInName("TARJ", payMethod.PM_Name) ? "TARJETA" :
                                                                                                                this.findInName("CRÉDITO", payMethod.PM_Name) ? "CRÉDITO" :
                                                                                                                    this.findInName("FISE", payMethod.PM_Name) ? "FISE" :
                                                                                                                        payMethod.PM_Name
                                                                                        }
                                                                                    </td>
                                                                                    <td className='p-1 col-sm-auto text-nowrap'>
                                                                                        {(payMethod.currency === 'USD' ? 'USD' : CURRENCY) + ' ' + FORMAT_NUMBER.new(payMethod.currency === 'USD' ? Number(String(payMethod.total).replace(/,/g, '')) : payMethod.Amount)}
                                                                                        {payMethod.currency === 'USD' &&
                                                                                            <span className="ml-2 pl-2 border-left text-info">{CURRENCY} {FORMAT_NUMBER.new(payMethod.Amount)}</span>
                                                                                        }
                                                                                    </td>
                                                                                    <td className='p-1 col-sm-auto'>
                                                                                        {/* <button
                                                                                            type="button"
                                                                                            class="btn btn-outline-danger"
                                                                                            onClick={() => this.RemovePaymentSale(index)}
                                                                                        > */}
                                                                                        {payMethod.SuccessTerminal ?
                                                                                            <i className="fa fa-check-circle-o" style={{ color: "#1fa638", margin: "1rem" }} />
                                                                                            :
                                                                                            <i className="fa fa-trash-o" style={{ color: "#dc3545", margin: "1rem" }} onClick={() => this.RemovePaymentSale(index)} />
                                                                                        }
                                                                                        {/* </button> */}
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        })}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        {(Number(PaymentSaleModel.TypeMethod) !== 2) &&
                                            <div className="card-details">
                                                <h3 className="title mt-4">Cambio:</h3>
                                                <div className="card row" style={{ fontSize: "xxx-large", border: "none", background: "#0499f212", boxShadow: "1px 1px 5px rgb(0 0 0 / 0%)" }}>
                                                    <div className=" text-center col-12 pb-2" >
                                                        <span style={{ color: "#0458b2", fontWeight: "bold" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(newOrderModel.TotalRestante)}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </form>
                                </div>
                                <div className="modal-footer">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-6 col-sm-4 mb-2 mb-sm-0">
                                                <button type="button" className="btn btn-secondary btn-block btn-lg" data-dismiss="modal" onClick={CancelPayment}>
                                                    Cancelar
                                                </button>
                                            </div>
                                            <div className="col-6 col-sm-8">
                                                <button className="btn btn-primary btn-block btn-lg" type="submit" data-toggle="modal" onClick={ValidateDocument}>
                                                    {(PaymentSaleModel && (Number(PaymentSaleModel.TypeMethod) === -1)) || newOrderModel.PaymentsToSale.find((paymentMethod) => Number(paymentMethod.TypeMethod) === -1) ? "Generar" : "Pagar"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <ValidationModal
                    idValidation="validationModal"
                    message="¿Esta seguro que quiere continuar?"
                    eventOnclick={CreateDocument}
                    eventOnclick2={this.CleanInfo}
                />

                <TicketModal
                    CloseBillModal={CloseBillModal}
                    newOrderModel={newOrderModel}
                    Print={Print}
                    _user={_user} />
                {showFiseModal && <StandardSelectModal
                    id="fiseModal"
                    title={"CÓDIGOS FISE"}
                    headers={[
                        { title: "Código", value: true, filter: true, field: "U_fise_codigo" },
                        { title: "Importe", value: true, filter: true, field: "U_importe" },
                    ]}
                    data={listFise ?? []}
                    selectAction={this.selectFiseCode}
                    selectedItems={selectedFise ?? []}
                    disabled={false}
                    idSelection="U_fise_codigo"
                    validNoSelection={true} />}

                {showNiubizModal &&
                    <NiubizModal
                        payment={currPayment}
                        RemovePaymentSaleByNiubiz={this.RemovePaymentSaleByNiubiz}
                        showAlert={showAlert}
                        addNiubizReference={this.addNiubizReference}
                    />
                }
            </div>
        );
    }
}

export default BillModal;